// // Navbar.jsx
//import React, { useEffect, useRef, useState, useContext } from "react";
// import { UserContext } from "../contexts/UserContext";
// import { UrlContext } from "../contexts/UrlContext";
// import { AppContext } from "../contexts/AppContext";
// import { useMsal } from "@azure/msal-react";
// import AddToProject from "./ExpertDetails/AddToProject";
// import EmailComposer from "../pages/EmailComposer";
// import { NavLink, useNavigate } from "react-router-dom";
// import { AnimatePresence, motion } from "framer-motion";
// import FiveStarRatingModal from "./FiveStarRatingModal";
// import Swal from "sweetalert2";
// // import "../styles/navbar.css";
// import {
//   Bell,
//   ChevronDown,
//   LayoutGrid,
//   LogOut,
//   Menu,
//   Search,
//   Settings,
//   Sparkles,
//   User,
//   X,
//   Mails,
//   FileBadge,
//   ChartColumnIcon,
//   FolderOpen,
//   UserRoundXIcon,
//   UserCog2,
//   UserCog2Icon,
//   RefreshCcwIcon,
//   Eye,
//   EyeOff,
//   LayoutDashboardIcon,
//   CodeSquare,
// } from "lucide-react";
// import logo from "../images/logo-min.png";
// import userDefaultImage from "../images/default-profile.png";

// export default function Navbar() {
//   const { API_URL } = useContext(UrlContext);
//   const { instance } = useMsal();
//   const navigate = useNavigate();
//   const { userData, userError, adminUser, msalAccount, notifications, setNotifications, showSpan } = useContext(UserContext);
//   const { sanitize, setSanitize, applications } = useContext(AppContext);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [profileOpen, setProfileOpen] = useState(false);
//   const [searchInput, setSearchInput] = useState("");
//   const profileRef = useRef(null);
//   const inputRef = useRef(null);
//   const databaseLink = "https://images.expertpowerhouse.com";
  
//   const [openPanel, setOpenPanel] = useState(false);
//   const [expertProfiles, setExpertProfiles] = useState([]);
//   const [clientData, setClientData] = useState([]);
//   const [isSearching, setIsSearching] = useState(false);
//   const [loadingPopup, setLoadingPopup] = useState(false);
//   const [searchExpanded, setSearchExpanded] = useState(false);

//   useEffect(() => {
//     if (userError) {
//       Swal.fire({ icon: "error", title: "Session expired!", text: "Please login again.", showConfirmButton: false, timer: 1500, });
//       setTimeout(() => {
//         const logoutRequest = {
//           account: msalAccount,
//         };
//         instance.logoutRedirect(logoutRequest);
//         localStorage.removeItem("eph-token");
//         localStorage.removeItem("accesstoken");
//         window.location.href = "/";
//       }, 2000);
//     }
//   }, [userData, userError]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (profileRef.current && !profileRef.current.contains(event.target)) {
//         setProfileOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSearch = async (e) => {
//     e.preventDefault();
//     inputRef.current?.blur();
//     setSearchExpanded(false);

//     setOpenPanel(false);
//     setExpertProfiles([]);
//     setClientData([]);

//     const query = searchInput.trim().toLowerCase().replace(/\s+/g, " ");
//     if (!query) return;

//     setIsSearching(true);
//     setSearchInput("");

//     try {
//       const res = await fetch(`${API_URL}search-consultant`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ searchInput: query }),
//       });

//       if (!res.ok) {
//         const text = await res.text().catch(() => "");
//         Swal.fire({
//           icon: "error",
//           title: "Search failed!",
//           text: `Search request failed (${res.status}): ${text}`,
//           showConfirmButton: false,
//           timer: 1500,
//         });
//       }

//       const data = await res.json();

//       if (data?.status !== "success") {
//         Swal.fire({
//           icon: "error",
//           title: "Search failed!",
//           text: "Internal error while searching profile!",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//       }

//       setMobileOpen(false);

//       if (data?.expertID) {
//         navigate(`/app/ExpertDetails/${data.expertID}`);
//         return;
//       }

//       if (data?.clientProjectID) {
//         navigate(`/app/AccountDetails/${data.clientProjectID}`);
//         return;
//       }

//       if (Array.isArray(data?.expertList) && data?.client) {
//         setExpertProfiles(data.expertList);
//         setClientData(data.client);
//         setOpenPanel(true);
//         return;
//       }

//       if (Array.isArray(data?.expertList)) {
//         setExpertProfiles(data.expertList);
//         setOpenPanel(true);
//         return;
//       }

//       setExpertProfiles([]);
//       setClientData([]);
//       setOpenPanel(true);
//     } catch (err) {
//       console.error("Search error:", err);
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   const fetchExcel = async () => {
//     try {
//       setLoadingPopup(true);
//       const authToken = localStorage.getItem("accesstoken");
//       const url = `${API_URL}fetch-quarterly-data`;
//       fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ authToken }),
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           if (data.status === "success") {
//             setLoadingPopup(false);
//             window.open(data.filePath, "_blank", "rel=noopener noreferrer");
//           } else {
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: data.message,
//             });
//             setLoadingPopup(false);
//           }
//         })
//         .catch((err) => console.log(err));
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleLogout = () => {
//     const logoutRequest = {
//       account: msalAccount,
//     };
//     instance.logoutRedirect();
//     localStorage.removeItem("eph-token");
//     localStorage.removeItem("accesstoken");
//     window.location.href = "/";
//   };

//   const navItems = [
//     {
//       label: "Projects",
//       to: "/app/ProjectsOverview",
//       icon: LayoutGrid,
//     },
//     {
//       label: "Consultants",
//       to: "/app/TopConsultants",
//       icon: Sparkles,
//     },
//     {
//       label: "Lists",
//       to: "/app/ListsOverview",
//       icon: FolderOpen,
//     },

//     ...(userData?.roles?.includes("Admin")
//       ? [
//           {
//             label: "Applications",
//             to: "/app/Usersapplications",
//             icon: FileBadge,
//             kind: "link",
//             badge: applications?.length || 0,
//           }
//         ]
//       : []),

//     ...(userData?.username?.includes("Bappi")
//       ? [
//           {
//             label: "Dashboard",
//             to: "/app/Dashboard",
//             icon: LayoutDashboardIcon,
//           },
//         ]
//       : []),

//   ];

//   const profileImage =  
//     userData?.profilePicture
//       ? userData?.profilePicture.includes("data:image")
//         ? userData?.profilePicture
//         : userData?.profilePicture !== ""
//         ? `${databaseLink}${userData?.profilePicture}`
//         : userDefaultImage
//       : userDefaultImage;


//   return (
//     <>
//       <header className="sticky top-0 w-full bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.18),transparent_35%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] backdrop-blur-xl" style={{zIndex: "9999"}}>
//         <div className="mx-auto flex h-[78px] w-full items-center justify-between px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center gap-2">
//             <motion.button
//               whileTap={{ scale: 0.98 }}
//               onClick={() => navigate("/app/ProjectSetup")}
//               className="flex items-center z-50 gap-3 rounded-2xl border border-slate-200/80 bg-white px-3 py-2 shadow-[0_10px_30px_rgba(15,23,42,0.06)] focus:outline-none cursor-pointer"
//               type="button"
//             >
//               <img src="https://cdn.prod.website-files.com/669f9a7768d5838eeab813ff/697c817702dc31f302e74738_eph-logo-10jahre-final-p-2000.png" alt="Company logo" className="h-9 w-auto" />
//               {/* <img src={logo} alt="Company logo" className="h-9 w-auto" /> */}
//               <div className="hidden xl:block">
//                 <p className="text-sm font-semibold text-slate-800">expertpowerhouse</p>
//                 <p className="text-[11px] text-slate-500">Workspace</p>
//               </div>
//             </motion.button>

//             {/* Main navlink items in the middle*/}
//             <div className="hidden md:flex items-center rounded-2xl z-50 border border-slate-200/80 bg-white p-1 shadow-[0_10px_30px_rgba(15,23,42,0.05)]">
//               {navItems.map((item) => {
//                 const Icon = item.icon;
//                 return (
//                   <NavLink key={item.to} to={item.to} end>
//                     {({ isActive }) => (
//                       <motion.span
//                         whileTap={{ scale: 0.98 }}
//                         className={[
//                           "relative inline-flex h-11 items-center gap-1 rounded-xl md:px-1 lg:px-3 xl:px-4 text-sm font-medium transition-all duration-200 cursor-pointer",
//                           isActive
//                             ? "bg-[#365561] text-white shadow-[0_10px_24px_rgba(54,85,97,0.22)]"
//                             : "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
//                         ].join(" ")}
//                       >
//                         <Icon className="h-4 w-4" />
//                         {item.label}

//                         {item.badge > 0 && (
//                           <span className="absolute -top-2 -right-0 inline-flex w-[22px] h-[22px] items-center justify-center rounded-full bg-red-500  text-[10px] font-semibold text-white shadow">
//                             {item.badge}
//                           </span>
//                         )}
//                       </motion.span>
//                     )}
//                   </NavLink>
//                 );
//               })}
//             </div>
//           </div>

//           <motion.div
//             initial={{ x: "100%", opacity: 0 }}
//             animate={{ x: 0, opacity: 1 }}
//             exit={{ x: "100%", opacity: 0 }}
//             transition={{ duration: 0.22, ease: "easeOut" }}
//             className="hidden xl:flex flex-wrap justify-center items-center opacity-80 rounded-2xl border border-slate-200/80 bg-white h-[53px] px-3 shadow-[0_10px_30px_rgba(15,23,42,0.06)] focus:outline-none cursor-pointer"
//             hidden = {!userData?.username?.includes("Bappi")}
//           >
//             EPH Live
//           </motion.div>
          
//           {/* Action buttons on the right */}
//           <div className="flex items-center z-50 gap-1 lg:gap-2">

//             {/* Search bar */}
//             <motion.form
//               onSubmit={handleSearch}
//               animate={{ width: searchExpanded ? 260 : 44}}
//               transition={{ duration: 0.28, ease: "easeInOut" }}
//               className="hidden md:flex h-[53px] ml-auto items-center gap-2 overflow-hidden rounded-2xl border border-slate-200/80 bg-white px-2.5 shadow-[0_10px_30px_rgba(15,23,42,0.05)] transition-[box-shadow,border-color] duration-300 focus-within:border-[#365561]/25 focus-within:shadow-[0_12px_36px_rgba(54,85,97,0.10)]"
//             >
//               {isSearching ? (
//                 <i className="fa-solid fa-spinner fa-spin ml-[3px]"></i>
//               ) : (
//                 <Search
//                   onClick={() => {
//                     setSearchExpanded(!searchExpanded);
//                     requestAnimationFrame(() => inputRef.current?.focus());
//                   }}
//                   className="h-5 w-5 shrink-0 cursor-pointer"
//                 />
//               )}

//               <input
//                 ref={inputRef}
//                 type="text"
//                 value={searchInput}
//                 onFocus={() => setSearchExpanded(true)}
//                 onChange={(e) => setSearchInput(e.target.value)}
//                 placeholder="Search clients and consultants"
//                 className="w-full bg-transparent text-sm text-slate-700 outline-none placeholder:text-slate-400"
//               />
//             </motion.form>

//             <AnimatePresence mode="wait" initial={false}>
//               {searchExpanded ? (
//                 // Search back button
//                 <motion.button
//                   key="search-back"
//                   initial={{ x: "100%", opacity: 0 }}
//                   animate={{ x: 0, opacity: 1 }}
//                   exit={{ x: "100%", opacity: 0 }}
//                   transition={{ duration: 0.22, ease: "easeOut" }}
//                   whileTap={{ scale: 0.96 }}
//                   onClick={() => {
//                     setSearchExpanded(false);
//                     setSearchInput("");
//                     inputRef.current?.blur();
//                   }}
//                   className="hidden md:inline-flex h-[53px] w-11 items-center justify-center rounded-2xl border border-slate-200/80 bg-white text-slate-600 shadow-[0_10px_30px_rgba(15,23,42,0.05)] focus:outline-none"
//                   type="button"
//                   aria-label="Collapse search"
//                 >
//                   <i className="fa-solid fa-arrow-left"></i>
//                 </motion.button>
//               ) : (
//                 <motion.div
//                   key="right-controls"
//                   initial={{ x: "100%", opacity: 0 }}
//                   animate={{ x: 0, opacity: 1 }}
//                   exit={{ x: "100%", opacity: 0 }}
//                   transition={{ duration: 0.22, ease: "easeOut" }}
//                   className="flex items-center gap-1 lg:gap-2"
//                 >
//                   <NotificationsPanel />

//                   {/* Profile dropdown with picture */}
//                   <div className="relative" ref={profileRef}>
//                     <motion.button
//                       whileTap={{ scale: 0.98 }}
//                       onClick={() => setProfileOpen((prev) => !prev)}
//                       className="flex h-[53px] items-center gap-2 rounded-2xl border border-slate-200/80 bg-white p-1 pr-3 shadow-[0_10px_30px_rgba(15,23,42,0.06)] transition hover:bg-slate-50 focus:outline-none"
//                       type="button"
//                     >
//                       <img
//                         src={profileImage}
//                         alt="User"
//                         className="h-9 w-9 rounded-xl object-cover"
//                         onError={(e) => {
//                           e.currentTarget.src = userDefaultImage;
//                         }}
//                       />
//                       <div className="hidden text-left lg:block">
//                         <p className="max-w-[110px] truncate text-[13px] font-semibold text-slate-800">
//                           {userData?.username || "User"}
//                         </p>
//                       </div>
//                       <ChevronDown className="h-4 w-4 text-slate-400" />
//                     </motion.button>

//                     <AnimatePresence>
//                       {profileOpen && (
//                         <motion.div
//                           initial={{ opacity: 0, y: 10, scale: 0.98 }}
//                           animate={{ opacity: 1, y: 0, scale: 1 }}
//                           exit={{ opacity: 0, y: 8, scale: 0.98 }}
//                           transition={{ duration: 0.18 }}
//                           className="absolute right-0 mt-3 w-72 overflow-hidden rounded-3xl border border-slate-200/80 bg-white p-2 shadow-[0_24px_60px_rgba(15,23,42,0.14)] backdrop-blur-xl"
//                         >
//                           <div className="mb-2 rounded-2xl bg-slate-50 p-3">
//                             <p className="truncate text-sm font-semibold text-slate-900">
//                               {userData?.username || "User"}
//                             </p>
//                             <p className="truncate text-[11px] text-slate-500">
//                               {userData?.email || "No email available"}
//                             </p>
//                           </div>

//                           <button
//                             hidden = {!(userData?.username?.includes("Bappi") || userData?.username?.includes("David"))}
//                             onClick={() => {
//                               setProfileOpen(false);
//                               navigate("/app/Dashboard");
//                             }}
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
//                             type="button"
//                           >
//                             <LayoutDashboardIcon className="h-4 w-4" />
//                             Dashboard
//                           </button>

//                           <button
//                             hidden = {!userData?.username?.includes("Bappi")}
//                             onClick={() => {
//                               setProfileOpen(false);
//                               navigate("/app/EphMail");
//                             }}
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
//                             type="button"
//                           >
//                             <Mails className="h-4 w-4" />
//                             EPH Email
//                           </button>

//                           <button
//                             hidden = {!userData?.username?.includes("Bappi")}
//                             onClick={() => {
//                               setProfileOpen(false);
//                               navigate("/app/FrontendTestPage");
//                             }}
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
//                             type="button"
//                           >
//                             <CodeSquare className="h-4 w-4" />
//                             Frontend Test Page
//                           </button>

//                           <button
//                             onClick={() => {
//                               setProfileOpen(false);
//                               navigate("/app/AccountSettings");
//                             }}
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
//                             type="button"
//                           >
//                             <Settings className="h-4 w-4" />
//                             Account Settings
//                           </button>

//                           <button
//                             hidden = {!userData?.roles?.includes("Admin")}
//                             onClick={() => {
//                               setProfileOpen(false);
//                               navigate("/app/ProjectProgressGantt");
//                             }}
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
//                             type="button"
//                           >
//                             <ChartColumnIcon className="h-4 w-4" />
//                             Projects Data
//                           </button>

//                           <button
//                             hidden = {!userData?.roles?.includes("Admin")}
//                             onClick={() => {
//                               setProfileOpen(false);
//                               fetchExcel();
//                             }}
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
//                             type="button"
//                           >
//                             <ChartColumnIcon className="h-4 w-4" />
//                             Quarterly Data
//                           </button>

//                           <button
//                             hidden = {!userData?.roles?.includes("Admin")}
//                             onClick={() => {
//                               setProfileOpen(false);
//                               navigate("/app/ManageUsers");
//                             }}
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
//                             type="button"
//                           >
//                             <UserCog2Icon className="h-4 w-4" />
//                             Manage Users
//                           </button>

//                           <button
//                             hidden = {!userData?.roles?.includes("Admin")}
//                             onClick={() => {
//                               setProfileOpen(false);
//                               navigate("/app/BlackListedExperts");
//                             }}
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
//                             type="button"
//                           >
//                             <UserRoundXIcon className="h-4 w-4" />
//                             Blacklisted Experts
//                           </button>

//                           <div
//                             hidden = {!userData?.roles?.includes("Admin")}
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
//                           >
//                             {sanitize ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
//                             Sanitize View
//                             <div class="custom-control custom-switch">
//                               <input
//                                 type="checkbox"
//                                 class="custom-control-input"
//                                 id="customSwitch1"
//                                 onChange={() => {
//                                   setSanitize(!sanitize);
//                                 }}
//                               />
//                               <label class="custom-control-label cursor-pointer" for="customSwitch1" />
//                             </div>
//                           </div>

//                           <div className="my-2 h-px bg-slate-200" />

//                           <button
//                             className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-rose-600 transition hover:bg-rose-50 focus:outline-none"
//                             type="button"
//                             onClick={handleLogout}
//                           >
//                             <LogOut className="h-4 w-4" />
//                             Log out
//                           </button>
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </div>
//                 </motion.div>
//               )}
//             </AnimatePresence>

//             {/* Menubar for small screen */}
//             <motion.button
//               whileTap={{ scale: 0.96 }}
//               onClick={() => setMobileOpen(true)}
//               className="inline-flex md:hidden h-12 w-11 items-center justify-center rounded-2xl border border-slate-200/80 bg-white text-slate-600 shadow-[0_10px_30px_rgba(15,23,42,0.05)] focus:outline-none"
//               type="button"
//               aria-label="Open menu"
//             >
//               <Menu className="h-5 w-5" />
//             </motion.button>
//           </div>
//         </div>
//       </header>

//       <AnimatePresence>
//         {mobileOpen && (
//           <>
//             <motion.div
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               onClick={() => setMobileOpen(false)}
//               className="fixed inset-0 z-40 bg-slate-900/30 backdrop-blur-sm md:hidden"
//             />

//             <motion.aside
//               initial={{ x: '100%' }}
//               animate={{ x: 0 }}
//               exit={{ x: '100%' }}
//               transition={{ type: 'spring', stiffness: 320, damping: 30 }}
//               className="fixed right-0 top-0 flex h-full w-[88%] max-w-sm flex-col border-l border-slate-200 bg-white px-4 py-3 shadow-[0_20px_50px_rgba(15,23,42,0.14)] lg:hidden"
//               style={{zIndex: 19999}}
//             >
//               <div className="mb-6 flex items-center justify-between">
//                 <div className="flex items-center gap-3">
//                   <img
//                     src="https://cdn.prod.website-files.com/669f9a7768d5838eeab813ff/697c817702dc31f302e74738_eph-logo-10jahre-final-p-2000.png"
//                     alt="Company logo"
//                     className="h-8 w-auto cursor-pointer"
//                     onClick={() => {
//                       navigate('/app/ProjectSetup');
//                       setMobileOpen(false);
//                     }}
//                   />
//                 </div>

//                 <button
//                   onClick={() => setMobileOpen(false)}
//                   className="rounded-2xl border border-slate-200 bg-white p-2.5 text-slate-600 shadow-sm focus:outline-none"
//                   type="button"
//                 >
//                   <X className="h-5 w-5" />
//                 </button>
//               </div>

//               <form onSubmit={handleSearch} className="mb-6">
//                 <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
//                   {isSearching ? <i class="fa-solid fa-spinner fa-spin"></i> : <Search className="h-4 w-4 text-slate-400" />}
//                   <input
//                     type="text"
//                     value={searchInput}
//                     onChange={(e) => setSearchInput(e.target.value)}
//                     placeholder="Search"
//                     className="w-full bg-transparent text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none"
//                   />
//                 </div>
//               </form>

//               <div className="space-y-2">
//                 {navItems.map((item) => {
//                   const Icon = item.icon;
//                   return (
//                     <NavLink
//                       key={item.to}
//                       to={item.to}
//                       end
//                       onClick={() => setMobileOpen(false)}
//                       className={({ isActive }) =>
//                         [
//                           'flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-medium transition',
//                           isActive
//                             ? 'bg-[#365561] text-white shadow-[0_10px_24px_rgba(54,85,97,0.22)]'
//                             : 'text-slate-700 hover:bg-slate-50',
//                         ].join(' ')
//                       }
//                     >
//                       <Icon className="h-4 w-4" />
//                       {item.label}
//                     </NavLink>
//                   );
//                 })}
//               </div>
//             </motion.aside>
//           </>
//         )}
//       </AnimatePresence>

//       {openPanel && (
//         <ExpertSuggestionPanel 
//           suggestions={expertProfiles}
//           client={clientData}
//           onClose={(e) => setOpenPanel(false)}
//         />
//       )}

//       {showSpan && (
//         <AnimatePresence>
//           <motion.div
//             initial={{ x: 300, opacity: 0 }}
//             animate={{ x: 0, opacity: 1 }}
//             exit={{ x: 300, opacity: 0 }}
//             transition={{ type: "spring", stiffness: 260, damping: 25 }}
//             className="fixed top-[88px] right-4 z-50"
//           >
//             <div className="flex items-center justify-start gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-[0_20px_50px_rgba(15,23,42,0.15)]">
              
//               {/* Left accent */}
//               <button className="focus:outline-none" onClick={() => window.location.reload()}>
//                 <RefreshCcwIcon className="h-8 w-8 text-green-500"/>
//               </button>

//               {/* Content */}
//               <div className="text-sm text-slate-700 leading-5">
//                 <p className="font-semibold text-slate-900">
//                   Update available
//                 </p>
//                 <p className="text-[12px] text-slate-500">
//                   Please refresh this tab to load the latest version
//                 </p>
//               </div>
//             </div>
//           </motion.div>
//         </AnimatePresence>
//       )}

//       {loadingPopup && (
//         <AnimatePresence>
//           <motion.div
//             className="fixed inset-0 bg-black/30 z-30"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             transition={{ duration: 0.2 }}
//           />
//         </AnimatePresence>
//       )}
//     </>
//   );
// }

// export function ExpertSuggestionPanel({ suggestions, client, onClose }) {
//   const isDownloaded = "/pictures/";
//   const DUMMY_IMG = "https://images.expertpowerhouse.com/kjknoi14214poj0890fldy13koj2lm/pictures/dummy.png"
//   const [expertData, setExpertData] = useState(suggestions);

//   const [searchExpand, setSearchExpand] = useState(false);
//   const [locationExpand, setLocationExpand] = useState(false);
//   const [backupData, setBackupData] = useState(suggestions);
//   const [filterName, setFilterName] = useState("");
//   const [filterLocation, setFilterLocation] = useState("");
//   const nameInputRef = useRef(null);
//   const locationInputRef = useRef(null);

//   useEffect(() => {
//     if (filterName || filterLocation) {
//       const filteredData = backupData.filter((item) => {
//         const name = item?.name?.toLowerCase();
//         const location = item?.location?.toLowerCase();
//         return (
//           name?.includes(filterName?.toLowerCase()) &&
//           location?.includes(filterLocation?.toLowerCase())
//         );
//       });
//       setExpertData(filteredData);
//     } else {
//       setExpertData(backupData);
//     }
//   }, [filterName, filterLocation, backupData]);

//   const resolveProfileImage = (profilePicture, isDownloaded) => {
//     if (!profilePicture || typeof profilePicture !== "string") {
//       return DUMMY_IMG;
//     }

//     const trimmed = profilePicture.trim();
//     if (!trimmed) return DUMMY_IMG;

//     if (/^https?:\/\//i.test(trimmed)) {
//       return trimmed;
//     }

//     if (isDownloaded && trimmed.includes(isDownloaded)) {
//       return `https://images.expertpowerhouse.com${trimmed}`;
//     }

//     return DUMMY_IMG;
//   };

//   function convertDateObject(date) {
//     const formatterDate = new Intl.DateTimeFormat('en-US', {
//       timeZone: 'UTC',
//       weekday: 'long',
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//     });

//     const time = new Date(date);

//     const parts = formatterDate.formatToParts(time);
//     const weekday = parts.find(p => p.type === 'weekday').value;
//     const day = parts.find(p => p.type === 'day').value;
//     const month = parts.find(p => p.type === 'month').value;
//     const year = parts.find(p => p.type === 'year').value;

//     return {
//       weekday,
//       day,
//       month,
//       year,
//     };
//   };

//   function getAvailableBorder(availablityDate) {
//     if (!availablityDate) return "";

//     const today = new Date();
//     const availDate = new Date(availablityDate);

//     if ( availablityDate === "Wed, 01 Jan 2020 00:00:00 GMT" || availablityDate === "Fri, 01 Jan 2010 00:00:00 GMT") {
//       return "";
//     } else if (availDate < today) {
//       return "rounded-tl rounded-bl border-2 border-green-500";
//     } else if (availDate > today) {
//       return "rounded-tl rounded-bl border-2 border-red-500";
//     }
//   };

//   return (
//     <AnimatePresence>
//       {/* Background Overlay */}
//       <motion.div
//         className="fixed inset-0 bg-black/30 z-30"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//         transition={{ duration: 0.2 }}
//         onClick={onClose}
//       />

//       {/* Panel */}
//       <motion.div
//         className="fixed top-[78px] right-0 h-full w-[800px] bg-white shadow-xl z-40 pt-2 px-4 pb-6 flex flex-col shadow"
//         initial={{ x: "100%" }}
//         animate={{ x: 0 }}
//         exit={{ x: "100%" }}
//         transition={{ type: "spring", stiffness: 300, damping: 30 }}
//         style={{ zIndex: 9999 }}
//       >
//         <div className="flex justify-between items-center mb-4 border-bottom ">
//           <h2 className="text-2xl font-semibold text-gray-800 mb-2">Consultant / Client search results</h2>
//           <button
//             className="text-gray-500 hover:text-black hover:bg-gray-200 border border-gray-500 px-[8px] py-[1px] rounded-full transition"
//             onClick={onClose}
//           >
//             <i className="fa-solid fa-xmark text-lg"></i>
//           </button>
//         </div>

//         <div className="space-y-3 overflow-y-auto flex-1">
//           {client?.length > 0 && (
//             <div className="list-group mb-10">
//               <h2 className="text-md font-semibold mb-2">{client.length} Client are found</h2>
//               {client.map((clientProfile) => (
//                 <a
//                   key={clientProfile.name}
//                   href={`/app/AccountDetails/${clientProfile.projectID}`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="list-group-item list-group-item-action list-group-item-light"
//                 >
//                   {clientProfile.name}
//                 </a>
//               ))}
//             </div>
//           )}

          
//           {/* Title and search bars */}
//           <h2 className="text-md font-semibold">{expertData.length} Consultants are found</h2>
//           {/* search bars */}
//           <div className="left-[280px] w-[700px]">
//             <ul className="search-con-filters list-unstyled form-inline">
//               <li className="search-con-name-filter">
//                 <span className="no-select">search name</span>
//                 <div className="search-con-search-box">
//                   <input
//                     className={
//                       searchExpand
//                         ? "search-con-search-input search-con-filter-expand"
//                         : "search-con-search-input"
//                     }
//                     placeholder="Search Name"
//                     onChange={(e) => setFilterName(e.target.value)}
//                     value={filterName}
//                     ref={nameInputRef}
//                   />
//                   <i
//                     className="search-con-search-icon fa-solid fa-magnifying-glass"
//                     onClick={(e) => {
//                       setSearchExpand(!searchExpand);
//                       // nameInputRef.current.focus()
//                     }}
//                   />
//                 </div>
//               </li>
//               <li className="search-con-location-filter ml-[100px]">
//                 <span className="no-select">Location</span>
//                 <div className="search-con-searchLoc-box ml-1">
//                   <input
//                     className={
//                       locationExpand
//                         ? "search-con-searchLoc-input search-con-location-expand"
//                         : "search-con-searchLoc-input"
//                     }
//                     placeholder="Location"
//                     onChange={(e) => setFilterLocation(e.target.value)}
//                     value={filterLocation}
//                     ref={locationInputRef}
//                   />
//                   <i
//                     className="search-con-searchLoc-icon fa-solid fa-magnifying-glass"
//                     onClick={(e) => {
//                       setLocationExpand(!locationExpand);
//                       // locationInputRef.current.focus()
//                     }}
//                   />
//                 </div>
//               </li>
//             </ul>
//           </div>
//           {/* ----------------- */}

//           {expertData.length > 0 ? (
//             <>
//               {expertData.map((data) => (
//                 <div
//                   key={data.id}
//                   className="flex border rounded-lg shadow-sm hover:bg-gray-50 transition overflow-hidden cursor-pointer"
//                   onClick={() => {window.open(`/app/ExpertDetails/${data.id}`, "_blank", "noopener,noreferrer");}}
//                 >
//                   {(() => {
//                     const available = getAvailableBorder(data.available_from);
//                     return (
//                       <a className={`shrink-0 ${available}`}>
//                         <div
//                           className="flex-item-share-profile-item-profile-picture"
//                           style={{
//                             width: "90px",
//                             height: "100%",
//                             backgroundColor: "#365561",
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             backgroundImage: `url(${resolveProfileImage(
//                               data.profile_picture,
//                               isDownloaded
//                             )})`,
//                             backgroundSize: "cover",
//                             backgroundPosition: "center",
//                             backgroundRepeat: "no-repeat",
//                           }}
//                         />
//                       </a>
//                     );
//                   })()}

//                   <div className="flex-1 min-w-0 p-2">
//                     <div className="flex flex-row justify-between">
//                       <p className="text-lg font-medium text-gray-800 truncate">
//                         {data.name}
//                       </p>
//                       <div onClick={(e) => {e.stopPropagation();}}>
//                         <AddToProject
//                           expertID={data.id}
//                           btnName={" Project"}
//                         />
//                       </div>
//                     </div>

//                     {/* 2-column grid so widths stay consistent */}
//                     <div className="mt-2 grid grid-cols-[260px_minmax(0,1fr)] gap-3">
//                       {/* Middle: fixed width */}
//                       <div className="min-w-0 w-[260px] flex-col justify-between">
//                         <div className="min-h-[140px]">
//                           <div className="flex items-start gap-2">
//                             <span className="leading-5 shrink-0">📧</span>
//                             <span className="text-sm text-gray-500 leading-5 break-words">
//                               {data.email || "No info"}
//                             </span>
//                           </div>

//                           <div className="flex items-start gap-2 mt-1">
//                             <span className="leading-5 shrink-0">🌍</span>
//                             <span className="text-sm text-gray-500 leading-5 break-words">
//                               {data.location || "No location data"}
//                             </span>
//                           </div>

//                           <div className="flex items-start gap-2 mt-1">
//                             <span className="leading-5 shrink-0">💬</span>
//                             <span className="text-sm text-gray-500 leading-5 break-words line-clamp-2">
//                               {data.available_comment || "No availability comment"}
//                             </span>
//                           </div>

//                           {(() => {
//                             const time = convertDateObject(data.available_from);

//                             if (!time) return null; // safety guard

//                             return (
//                               <div className="flex items-start gap-2 mt-1">
//                                 <span className="leading-5 shrink-0">📆</span>
//                                 <span className="text-sm text-gray-500 leading-5 break-words line-clamp-2">
//                                   {`${time.weekday}, ${time.day} ${time.month} ${time.year}`}
//                                 </span>
//                               </div>
//                             );
//                           })()}

//                         </div>

//                         <li className="search-con-exLogo-section list-none">
//                           {data.logo1 ? <img src={data.logo1} alt="" /> : null}
//                           {data.logo2 ? <img src={data.logo2} alt="" /> : null}
//                           {data.logo3 ? <img src={data.logo3} alt="" /> : null}
//                           {data.logo4 ? <img src={data.logo4} alt="" /> : null}
//                           {data.logo5 ? <img src={data.logo5} alt="" /> : null}
//                         </li>
//                       </div>

//                       {/* Right: takes remaining space, but doesn't get pushed by middle */}
//                       <div className="min-w-0 space-y-2">
//                         <div>
//                           <p className="text-xs text-gray-500 font-medium mb-1">Summary</p>
//                           <div className="bg-gray-100 p-2 rounded text-sm text-gray-700 h-16 overflow-y-auto whitespace-pre-wrap break-words">
//                             {data.summary || "No summary available."}
//                           </div>
//                         </div>

//                         <div>
//                           <p className="text-xs text-gray-500 font-medium mb-1">Experience</p>
//                           <div className="bg-gray-100 p-2 rounded text-sm text-gray-700 h-16 overflow-y-auto whitespace-pre-wrap break-words">
//                             {data.experience || "No experience provided."}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </>
//           ) : (
//             <p className="text-gray-500 text-sm">No experts found.</p>
//           )}
//         </div>

//         <div className="mb-[70px]"></div>
//       </motion.div>
//     </AnimatePresence>
//   );
// }


// export function NotificationsPanel() {
//   const {
//     notifications,
//     projNotifications,
//     getToKnowNotifications,
//     expertCallNotifications,
//     invitationsAccepted,
//     joinNotifications,
//     clientNotifications,
//     setClientNotifications,
//     projectEndingNotifications,
//     ratingNotifications,
//   } = useContext(UserContext);

//   const [composeEmail, setComposeEmail] = useState(false);
//   const [emailDetails, setEmailDetails] = useState("");
//   const [loadingPopup, setLoadingPopup] = useState(false);

//   const { API_URL } = useContext(UrlContext);
//   const navigate = useNavigate();

//   const [showNotification, setShowNotification] = useState(false);
//   const [groupedClientNotifications, setGroupedClientNotifications] = useState(
//     []
//   );
//   const [sortedNotifications, setSortedNotifications] = useState([]);
//   const [showRatingModal, setShowRatingModal] = useState(false);
//   const [ratingModalExperts, setRatingModalExperts] = useState([]);
//   const [activeRatingNotification, setActiveRatingNotification] = useState(null);

//   const notificationRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         notificationRef.current &&
//         !notificationRef.current.contains(event.target)
//       ) {
//         setTimeout(() => {
//           setShowNotification(false);
//         }, 100);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     const result = clientNotifications.reduce((acc, item) => {
//       const existing = acc.find((el) => el.zohoID === item.zohoID);
//       if (existing) {
//         existing.count += 1;
//       } else {
//         acc.push({ ...item, count: 1 });
//       }
//       return acc;
//     }, []);
//     setGroupedClientNotifications(result);
//   }, [clientNotifications]);

//   useEffect(() => {
//     const array = [
//       ...notifications,
//       ...projNotifications,
//       ...getToKnowNotifications,
//       ...expertCallNotifications,
//       ...invitationsAccepted,
//       ...joinNotifications,
//       ...groupedClientNotifications,
//       ...projectEndingNotifications,
//       ...ratingNotifications,
//     ];
//     array.sort((a, b) => new Date(b.date) - new Date(a.date));
//     setSortedNotifications(array);
//   }, [
//     notifications,
//     projNotifications,
//     getToKnowNotifications,
//     expertCallNotifications,
//     invitationsAccepted,
//     joinNotifications,
//     groupedClientNotifications,
//     projectEndingNotifications,
//     ratingNotifications,
//   ]);

//   const handleProjectNameCrossClick = (event, projectID, notification) => {
//     event.preventDefault();
//     const ephToken = localStorage.getItem("eph-token");
//     const token = JSON.parse(ephToken).value;
//     const url = `${API_URL}update-project-dates`;

//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-access-token": token,
//       },
//       body: JSON.stringify({ projectID }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           const updateItems = sortedNotifications.filter(
//             (item) => item !== notification
//           );
//           setSortedNotifications(updateItems);
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Something went wrong!",
//           });
//         }
//       })
//       .catch(() => {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong!",
//         });
//       });
//   };

//   const handleProjectNameClick = (event, projectID) => {
//     event.preventDefault();
//     const ephToken = localStorage.getItem("eph-token");
//     const token = JSON.parse(ephToken).value;
//     const url = `${API_URL}update-project-dates`;

//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-access-token": token,
//       },
//       body: JSON.stringify({ projectID }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           window.location.href = `/app/ProjectDetails/${projectID}`;
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Something went wrong!",
//           });
//         }
//       })
//       .catch(() => {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong!",
//         });
//       });
//   };

//   const handleNotificationClick = (event, notificationData, clicked) => {
//     if (event?.preventDefault) {
//       event.preventDefault();
//     }

//     const projID = notificationData.projectID;
//     const notificationType = notificationData.type;

//     const ephToken = localStorage.getItem("eph-token");
//     const token = JSON.parse(ephToken).value;
//     const url = `${API_URL}update-notifications`;

//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-access-token": token,
//       },
//       body: JSON.stringify({ notificationData }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           if (clicked === "notification") {
//             if (notificationType === "Get-to-know") {
//               const updateItems = sortedNotifications.filter(
//                 (item) => item !== notificationData
//               );
//               setSortedNotifications(updateItems);
//               window.location.href = `/app/ProjectDetails/${projID}`;
//             } else if (notificationType === "Expert Call") {
//               const updateItems = sortedNotifications.filter(
//                 (item) => item !== notificationData
//               );
//               setSortedNotifications(updateItems);
//               window.location.href = `/app/ProjectDetails/${projID}`;
//             } else if (notificationType === "Invitation-accepted") {
//               const updateItems = sortedNotifications.filter(
//                 (item) => item !== notificationData
//               );
//               setSortedNotifications(updateItems);
//             } else if (notificationType === "Request-join") {
//               const updateItems = sortedNotifications.filter(
//                 (item) => item !== notificationData
//               );
//               setSortedNotifications(updateItems);
//             } else if (notificationType === "Client-notification") {
//               const updateItems = clientNotifications.filter(
//                 (item) => item.projectID !== notificationData.projectID
//               );
//               setClientNotifications(updateItems);
//             }
//           } else {
//             if (
//               notificationType === "Get-to-know" ||
//               notificationType === "Expert Call" ||
//               notificationType === "Invitation-accepted" ||
//               notificationType === "Request-join" ||
//               notificationType === "Project Ending" ||
//               notificationType === "Rate Notification"
//             ) {
//               const updateItems = sortedNotifications.filter(
//                 (item) => item !== notificationData
//               );
//               setSortedNotifications(updateItems);
//             } else if (notificationType === "Client-notification") {
//               const updateItems = clientNotifications.filter(
//                 (item) => item.projectID !== notificationData.projectID
//               );
//               setClientNotifications(updateItems);
//             }
//           }
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Something went wrong!",
//           });
//         }
//       })
//       .catch(() => {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong!",
//         });
//       });
//   };

//   const handleEmailButtonCloseClick = (expertID, notification) => {
//     const url = `${API_URL}navbar-close-email`;

//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ expertID }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           const updateItems = sortedNotifications.filter(
//             (item) => item !== notification
//           );
//           setSortedNotifications(updateItems);
//           setEmailDetails(data.emailDetails);
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Something went wrong!",
//           });
//         }
//       })
//       .catch(() => {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong!",
//         });
//       });
//   };

//   const handleEmailButtonClick = (expertID, notification) => {
//     setLoadingPopup(true);
//     const ephToken = localStorage.getItem("eph-token");
//     const token = JSON.parse(ephToken).value;
//     const url = `${API_URL}navbar-send-email`;

//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-access-token": token,
//       },
//       body: JSON.stringify({ expertID }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           const updateItems = sortedNotifications.filter(
//             (item) => item !== notification
//           );
//           setSortedNotifications(updateItems);
//           setEmailDetails(data.emailDetails);
//           setComposeEmail(true);
//           setLoadingPopup(false);
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Something went wrong!",
//           });
//         }
//       })
//       .catch(() => {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong!",
//         });
//       });
//   };

//   function timeAgo(unixTimestamp) {
//     const now = Date.now();
//     const difference = now - unixTimestamp * 1000;

//     const absDifference = Math.abs(difference);
//     const minutes = Math.floor(absDifference / (1000 * 60));
//     const hours = Math.floor(absDifference / (1000 * 60 * 60));
//     const days = Math.floor(absDifference / (1000 * 60 * 60 * 24));
//     const months = Math.floor(absDifference / (1000 * 60 * 60 * 24 * 30));

//     if (difference >= 0) {
//       if (minutes < 60) {
//         return minutes === 1 ? "a minute ago" : `${minutes} minutes ago`;
//       } else if (hours < 24) {
//         return hours === 1 ? "an hour ago" : `${hours} hours ago`;
//       } else if (days < 2) {
//         return "yesterday";
//       } else if (days < 30) {
//         return `${days} days ago`;
//       } else {
//         return months === 1 ? "a month ago" : `${months} months ago`;
//       }
//     } else {
//       if (minutes < 60) {
//         return minutes === 1 ? "in a minute" : `in ${minutes} minutes`;
//       } else if (hours < 24) {
//         return hours === 1 ? "in an hour" : `in ${hours} hours`;
//       } else if (days < 2) {
//         return "tomorrow";
//       } else if (days < 30) {
//         return `in ${days} days`;
//       } else {
//         return months === 1 ? "in a month" : `in ${months} months`;
//       }
//     }
//   }

//   const handleRatingNotificationClick = (event, notification) => {
//     event.preventDefault();
//     setRatingModalExperts(notification.experts);
//     setActiveRatingNotification(notification);
//     setShowRatingModal(true);
//   };

//   const renderNotificationRow = (item, index) => {
//     const cardBase =
//       "relative rounded-2xl border border-slate-200 bg-white p-3 shadow-sm transition hover:bg-slate-50";
//     const closeBtn =
//       "absolute right-2 top-2 inline-flex h-7 w-7 items-center justify-center rounded-xl text-slate-400 transition hover:bg-slate-100 hover:text-slate-700";
//     const meta = "mt-2 text-[11px] text-slate-500";
//     const actionLink = "font-semibold text-[#365561]";
//     const iconBtn =
//       "inline-flex h-8 w-8 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50";

//     if (item.type === "notifications") {
//       return (
//         <div key={index} className={cardBase}>
//           <button
//             className={closeBtn}
//             onClick={() => handleEmailButtonCloseClick(item.expertID, item)}
//             type="button"
//             title="Delete Notification"
//           >
//             <X className="h-4 w-4" />
//           </button>

//           <div className="pr-8">
//             <div className="flex items-start justify-between gap-3">
//               <p className="text-sm leading-6 text-slate-700">
//                 <a
//                   href={`/app/ExpertDetails/${item.expertID}`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className={actionLink}
//                 >
//                   {item.expertName}
//                 </a>{" "}
//                 is going to be available soon!
//               </p>

//               {!item.emailSent ? (
//                 <button
//                   type="button"
//                   className={iconBtn}
//                   onClick={() => handleEmailButtonClick(item.expertID, item)}
//                   title="Send Email"
//                 >
//                   <Mails className="h-4 w-4" />
//                 </button>
//               ) : (
//                 <span className="rounded-xl bg-emerald-50 px-2.5 py-1 text-[11px] font-medium text-emerald-700">
//                   Email Sent
//                 </span>
//               )}
//             </div>

//             {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
//           </div>
//         </div>
//       );
//     }

//     if (item.type === "project") {
//       return (
//         <div key={index} className={cardBase}>
//           <button
//             className={closeBtn}
//             onClick={(event) => handleProjectNameCrossClick(event, item.projectID, item)}
//             type="button"
//             title="Delete Notification"
//           >
//             <X className="h-4 w-4" />
//           </button>

//           <div className="pr-8">
//             <p className="text-sm leading-6 text-slate-700">
//               The project{" "}
//               <a
//                 href=""
//                 rel="noopener noreferrer"
//                 className={actionLink}
//                 onClick={(event) => handleProjectNameClick(event, item.projectID)}
//               >
//                 {item.projectName} ({item.zohoID})
//               </a>{" "}
//               is idle for a while. Please take the necessary action.
//             </p>
//             {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
//           </div>
//         </div>
//       );
//     }

//     if (item.type === "Get-to-know") {
//       return (
//         <div key={index} className={cardBase}>
//           <button
//             className={closeBtn}
//             onClick={(event) => handleNotificationClick(event, item, "close")}
//             type="button"
//             title="Delete Notification"
//           >
//             <X className="h-4 w-4" />
//           </button>

//           <a
//             href=""
//             rel="noopener noreferrer"
//             onClick={(event) =>
//               handleNotificationClick(event, item, "notification")
//             }
//             className="block pr-8"
//           >
//             <p className="text-sm leading-6 text-slate-700">
//               The Get-To-Know call with <b>{item.expertName}</b> in the project{" "}
//               <b>{item.zohoID}</b> was conducted. Do follow-up with the expert.
//             </p>
//             {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
//           </a>
//         </div>
//       );
//     }

//     if (item.type === "Expert Call") {
//       return (
//         <div key={index} className={cardBase}>
//           <button
//             className={closeBtn}
//             onClick={(event) => handleNotificationClick(event, item, "close")}
//             type="button"
//             title="Delete Notification"
//           >
//             <X className="h-4 w-4" />
//           </button>

//           <a
//             href=""
//             rel="noopener noreferrer"
//             onClick={(event) =>
//               handleNotificationClick(event, item, "notification")
//             }
//             className="block pr-8"
//           >
//             <p className="text-sm leading-6 text-slate-700">
//               The Expert Call with <b>{item.expertName}</b> in the project{" "}
//               <b>{item.zohoID}</b> was conducted. Do process the expert for
//               finalization.
//             </p>
//             {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
//           </a>
//         </div>
//       );
//     }

//     if (item.type === "Invitation-accepted") {
//       return (
//         <div
//           key={index}
//           className={`${cardBase} cursor-pointer`}
//           onClick={(event) => {
//             navigate(`/app/ProjectDetails/${item.projectID}`);
//             handleNotificationClick(event, item, "notification");
//           }}
//         >
//           <button
//             className={closeBtn}
//             onClick={(event) => {event.stopPropagation(); handleNotificationClick(event, item, "close")}}
//             type="button"
//             title="Delete Notification"
//           >
//             <X className="h-4 w-4" />
//           </button>

//           <div className="pr-8">
//             <p className="text-sm leading-6 text-slate-700">
//               <b className="text-[#365561]">{item.expertName}</b> has accepted
//               your invitation to project{" "}
//               <b className="text-[#365561]">{item.zohoID}</b>
//             </p>
//             {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
//           </div>
//         </div>
//       );
//     }

//     if (item.type === "Request-join") {
//       return (
//         <div
//           key={index}
//           className={`${cardBase} cursor-pointer`}
//           onClick={(event) => {
//             navigate(`/app/ProjectDetails/${item.projectID}`);
//             handleNotificationClick(event, item, "notification");
//           }}
//         >
//           <button
//             className={closeBtn}
//             onClick={(event) => {
//               event.stopPropagation();
//               handleNotificationClick(event, item, "close");
//             }}
//             type="button"
//             title="Delete Notification"
//           >
//             <X className="h-4 w-4" />
//           </button>

//           <div className="pr-8">
//             <p className="text-sm leading-6 text-slate-700">
//               <b className="text-[#365561]">{item.expertName}</b> requested to
//               join project <b className="text-[#365561]">{item.zohoID}</b>
//             </p>
//             {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
//           </div>
//         </div>
//       );
//     }

//     if (item.type === "Client-notification") {
//       return (
//         <div
//           key={index}
//           className={`${cardBase} cursor-pointer`}
//           onClick={(event) => {
//             navigate(`/app/ProjectSummary/${item.projectID}`);
//             handleNotificationClick(event, item, "notification");
//           }}
//         >
//           <button
//             className={closeBtn}
//             onClick={(event) => {event.stopPropagation(); handleNotificationClick(event, item, "close")}}
//             type="button"
//             title="Delete Notification"
//           >
//             <X className="h-4 w-4" />
//           </button>

//           <div className="pr-8">
//             <p className="text-sm leading-6 text-slate-700">
//               <b className="text-[#365561]">Project {item.zohoID}</b> received{" "}
//               {item.count > 1 ? `${item.count} new inputs` : "a new input"} from
//               client
//             </p>
//             {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
//           </div>
//         </div>
//       );
//     }

//     if (item.type === "Project Ending") {
//       return (
//         <div key={index} className={cardBase}>
//           <button
//             className={closeBtn}
//             onClick={(event) => handleNotificationClick(event, item, "close")}
//             type="button"
//             title="Delete Notification"
//           >
//             <X className="h-4 w-4" />
//           </button>

//           <a
//             href={`/app/ProjectInformation/${item.projectID}/${item.expertID}/0/1`}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="block pr-8"
//           >
//             <p className="text-sm leading-6 text-slate-700">
//               The project{" "}
//               <span className={actionLink}>
//                 {item.projectName} ({item.zohoID})
//               </span>{" "}
//               with the Expert <b>{item.expertName}</b> is ending soon. Please
//               take the necessary action.
//             </p>
//             {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
//           </a>
//         </div>
//       );
//     }

//     if (item.type === "Rate Notification") {
//       return (
//         <div key={index} className={cardBase}>
//           <button
//             className={closeBtn}
//             onClick={(event) => handleNotificationClick(event, item, "close")}
//             type="button"
//             title="Delete Notification"
//           >
//             <X className="h-4 w-4" />
//           </button>

//           <div className="pr-8">
//             <div className="flex items-start justify-between gap-3">
//               <p className="text-sm leading-6 text-slate-700">
//                 Rate your experience with consultant/expert{" "}
//                 <b>{item.expertName}</b> in project{" "}
//                 <b>
//                   {item.projectName} ({item.zohoID})
//                 </b>
//                 .
//               </p>

//               <button
//                 type="button"
//                 className={iconBtn}
//                 onClick={(e) => handleRatingNotificationClick(e, item)}
//                 title="Rate Expert"
//               >
//                 <i className="fa fa-star-o" />
//               </button>
//             </div>

//             {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
//           </div>
//         </div>
//       );
//     }

//     return null;
//   };

//   return (
//     <>
//       <div className="relative" ref={notificationRef}>
//         <motion.button
//           whileTap={{ scale: 0.98 }}
//           onClick={() => setShowNotification((prev) => !prev)}
//           className="relative hidden sm:inline-flex h-[53px] w-12 items-center justify-center rounded-2xl border border-slate-200/80 bg-white text-slate-600 shadow-[0_10px_30px_rgba(15,23,42,0.05)] transition hover:bg-slate-50 focus:outline-none"
//           type="button"
//           aria-label="Notifications"
//         >
//           <Bell className="h-4.5 w-4.5" />

//           {sortedNotifications?.length > 0 && (
//             <span className="absolute -right-1 -top-1 inline-flex w-[22px] h-[22px] items-center justify-center rounded-full bg-red-500 text-[10px] font-semibold text-white">
//               {sortedNotifications.length}
//             </span>
//           )}
//         </motion.button>

//         <AnimatePresence>
//           {showNotification && (
//             <motion.div
//               initial={{ opacity: 0, y: 10, scale: 0.98 }}
//               animate={{ opacity: 1, y: 0, scale: 1 }}
//               exit={{ opacity: 0, y: 8, scale: 0.98 }}
//               transition={{ duration: 0.18 }}
//               className="absolute right-0 mt-3 w-[420px] overflow-hidden rounded-3xl border border-slate-200/80 bg-white p-2 shadow-[0_24px_60px_rgba(15,23,42,0.14)] backdrop-blur-xl"
//             >
//               <div className="mb-2 rounded-2xl bg-slate-50 px-3 py-3">
//                 <div className="flex items-center justify-between gap-3">
//                   <div>
//                     <p className="text-sm font-semibold text-slate-900">
//                       Notifications
//                     </p>
//                     <p className="text-[11px] text-slate-500">
//                       {sortedNotifications.length} item
//                       {sortedNotifications.length === 1 ? "" : "s"}
//                     </p>
//                   </div>

//                   <button
//                     type="button"
//                     onClick={() => setShowNotification(false)}
//                     className="inline-flex h-8 w-8 items-center justify-center rounded-xl text-slate-400 transition hover:bg-white hover:text-slate-700"
//                   >
//                     <X className="h-4 w-4" />
//                   </button>
//                 </div>
//               </div>

//               <div className="max-h-[480px] space-y-2 overflow-y-auto pr-1">
//                 {sortedNotifications.length > 0 ? (
//                   sortedNotifications.map((item, index) =>
//                     renderNotificationRow(item, index)
//                   )
//                 ) : (
//                   <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center">
//                     <p className="text-sm font-medium text-slate-700">
//                       No notifications
//                     </p>
//                     <p className="mt-1 text-[11px] text-slate-500">
//                       You’re all caught up.
//                     </p>
//                   </div>
//                 )}
//               </div>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </div>

//       {showRatingModal && (
//         <FiveStarRatingModal
//           experts={ratingModalExperts}
//           onSubmit={async (ratings, comments) => {
//             try {
//               const ephToken = localStorage.getItem("eph-token");
//               const token = JSON.parse(ephToken).value;

//               const ratingData = ratingModalExperts.map((expert) => ({
//                 expertId: expert.ID,
//                 projectId:
//                   activeRatingNotification?.projectID || expert.projectId,
//                 rating: ratings[expert.ID] || 0,
//                 comment: comments[expert.ID] || "",
//                 expertName: expert.expertName,
//               }));

//               await fetch(`${API_URL}submit-expert-ratings`, {
//                 method: "POST",
//                 headers: {
//                   "Content-Type": "application/json",
//                   "x-access-token": token,
//                 },
//                 body: JSON.stringify({ ratings: ratingData }),
//               });
//             } catch (error) {}

//             setShowRatingModal(false);
//             setActiveRatingNotification(null);
//             setRatingModalExperts([]);
//             setSortedNotifications(
//               sortedNotifications.filter((n) => n !== activeRatingNotification)
//             );
//           }}
//           onSkip={() => {
//             handleNotificationClick(null, activeRatingNotification, "close");
//             setShowRatingModal(false);
//             setActiveRatingNotification(null);
//             setRatingModalExperts([]);
//           }}
//         />
//       )}


//       {composeEmail && (
//         <EmailComposer
//           emailDetails={emailDetails}
//           onClose={() => setComposeEmail(false)}
//           onSend={(modifiedEmail) => {
//             setLoadingPopup(true);

//             console.log("Sending modified email:", modifiedEmail);
//             const authToken = localStorage.getItem("accesstoken");
//             const tokenObj = localStorage.getItem("eph-token");
//             const url = `${API_URL}send-email-through-graphapi`;

//             fetch(url, {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//                 "x-access-token": authToken,
//                 tokenObj: JSON.parse(tokenObj).value,
//               },
//               body: JSON.stringify(modifiedEmail),
//             })
//               .then((res) => res.json())
//               .then((data) => {
//                 setLoadingPopup(false);

//                 if (data.status === "success") {
//                   setComposeEmail(false);
//                   const updatedNotificationList = notifications.map((item) => {
//                     if (item.expertID === modifiedEmail.expertID) {
//                       item.emailSent = true;
//                     }
//                     return item;
//                   });
//                   // setNotifications(updatedNotificationList);
//                   Swal.fire({
//                     icon: "success",
//                     title: "Email sent successfully",
//                     showConfirmButton: false,
//                     timer: 1500,
//                   });
//                 } else if (data.status === "error") {
//                   Swal.fire({
//                     icon: "error",
//                     title: "Error",
//                     text: `${data.message}`,
//                     showConfirmButton: false,
//                     timer: 1500,
//                   });
//                 }

//               })
//               .catch((err) => console.log(err));
//           }}
//         />
//       )}
//     </>
//   );
// }




import React, { useEffect, useMemo, useRef, useState, useContext } from "react";
import { createPortal } from "react-dom";
import { UserContext } from "../contexts/UserContext";
import { UrlContext } from "../contexts/UrlContext";
import { AppContext } from "../contexts/AppContext";
import { useMsal } from "@azure/msal-react";
import AddToProject from "./ExpertDetails/AddToProject";
import EmailComposer from "../pages/EmailComposer";
import { NavLink, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import FiveStarRatingModal from "./FiveStarRatingModal";
import FeedbackModal from "./ProjectDetails/FeedbackModal";
import Swal from "sweetalert2";
// import "../styles/navbar.css";
import {
  Bell,
  ChevronDown,
  LayoutGrid,
  LogOut,
  Menu,
  Search,
  Settings,
  Sparkles,
  User,
  X,
  Mails,
  FileBadge,
  ChartColumnIcon,
  FolderOpen,
  UserRoundXIcon,
  UserCog2,
  UserCog2Icon,
  RefreshCcwIcon,
  Eye,
  EyeOff,
  LayoutDashboardIcon,
  CodeSquare,
} from "lucide-react";
import logo from "../images/logo-min.png";
import userDefaultImage from "../images/default-profile.png";

export default function Navbar() {
  const { API_URL } = useContext(UrlContext);
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { userData, userError, adminUser, msalAccount, notifications, setNotifications, showSpan } = useContext(UserContext);
  const { sanitize, setSanitize, applications, allExpertSuggestions = [] } = useContext(AppContext);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const profileRef = useRef(null);
  const inputRef = useRef(null);
  const databaseLink = "https://images.expertpowerhouse.com";
  
  const [openPanel, setOpenPanel] = useState(false);
  const [expertProfiles, setExpertProfiles] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [searchExpanded, setSearchExpanded] = useState(false);
  const [selectedExpertSuggestion, setSelectedExpertSuggestion] = useState(null);
  const [searchSuggestionOpen, setSearchSuggestionOpen] = useState(false);

  useEffect(() => {
    if (userError) {
      Swal.fire({ icon: "error", title: "Session expired!", text: "Please login again.", showConfirmButton: false, timer: 1500, });
      setTimeout(() => {
        const logoutRequest = {
          account: msalAccount,
        };
        instance.logoutRedirect(logoutRequest);
        localStorage.removeItem("eph-token");
        localStorage.removeItem("accesstoken");
        window.location.href = "/";
      }, 2000);
    }
  }, [userData, userError]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const normaliseSearchValue = (value = "") =>
    String(value || "").trim().toLowerCase().replace(/\s+/g, " ");

  const consultantSuggestions = useMemo(() => {
    const query = normaliseSearchValue(searchInput);

    if (query.length < 2 || selectedExpertSuggestion) return [];

    return (allExpertSuggestions || [])
      .filter((expert) => {
        const name = String(expert?.name || "").trim();
        return name && name.toLowerCase().includes(query);
      })
      .slice(0, 100);
  }, [allExpertSuggestions, searchInput, selectedExpertSuggestion]);

  const selectExpertSuggestion = async (expert) => {
    if (!expert?.id || !expert?.name || isSearching) return;

    setSelectedExpertSuggestion(expert);
    setSearchInput(expert.name);
    setSearchSuggestionOpen(false);

    await executeSearch({
      query: expert.name,
      expertID: expert.id,
    });
  };

  const clearSelectedExpertSuggestion = () => {
    setSelectedExpertSuggestion(null);
  };

  const executeSearch = async ({ query, expertID = null }) => {
    const normalizedQuery = normaliseSearchValue(query);
    if (!normalizedQuery) return;

    inputRef.current?.blur();
    setSearchExpanded(false);
    setSearchSuggestionOpen(false);
    setOpenPanel(false);
    setExpertProfiles([]);
    setClientData([]);
    setIsSearching(true);

    try {
      const res = await fetch(`${API_URL}search-consultant`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          searchInput: normalizedQuery,
          expertID,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok || data?.status !== "success") {
        throw new Error(
          data?.text || `Search request failed (${res.status}).`
        );
      }

      setMobileOpen(false);
      setSearchInput("");

      if (data?.expertID) {
        navigate(`/app/ExpertDetails/${data.expertID}`);
        return;
      }

      if (data?.clientProjectID) {
        navigate(`/app/AccountDetails/${data.clientProjectID}`);
        return;
      }

      if (Array.isArray(data?.expertList) && data?.client) {
        setExpertProfiles(data.expertList);
        setClientData(data.client);
        setOpenPanel(true);
        return;
      }

      if (Array.isArray(data?.expertList)) {
        setExpertProfiles(data.expertList);
        setOpenPanel(true);
        return;
      }

      setExpertProfiles([]);
      setClientData([]);
      setOpenPanel(true);
    } catch (err) {
      console.error("Search error:", err);
      Swal.fire({
        icon: "error",
        title: "Search failed!",
        text: err.message || "Internal error while searching profile!",
        showConfirmButton: false,
        timer: 1500,
      });
    } finally {
      setIsSearching(false);
      setSelectedExpertSuggestion(null);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();

    await executeSearch({
      query: selectedExpertSuggestion?.name || searchInput,
      expertID: selectedExpertSuggestion?.id || null,
    });
  };

  const fetchExcel = async () => {
    try {
      setLoadingPopup(true);
      const authToken = localStorage.getItem("accesstoken");
      const url = `${API_URL}fetch-quarterly-data`;
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ authToken }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setLoadingPopup(false);
            window.open(data.filePath, "_blank", "rel=noopener noreferrer");
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: data.message,
            });
            setLoadingPopup(false);
          }
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleLogout = () => {
    const logoutRequest = {
      account: msalAccount,
    };
    instance.logoutRedirect();
    localStorage.removeItem("eph-token");
    localStorage.removeItem("accesstoken");
    window.location.href = "/";
  };

  const navItems = [
    {
      label: "Projects",
      to: "/app/ProjectsOverview",
      icon: LayoutGrid,
    },
    {
      label: "Consultants",
      to: "/app/TopConsultants",
      icon: Sparkles,
    },
    {
      label: "Lists",
      to: "/app/ListsOverview",
      icon: FolderOpen,
    },

    ...(userData?.roles?.includes("Admin")
      ? [
          {
            label: "Applications",
            to: "/app/Usersapplications",
            icon: FileBadge,
            kind: "link",
            badge: applications?.length || 0,
          }
        ]
      : []),

    // ...(userData?.username?.includes("Bappi")
    //   ? [
    //       {
    //         label: "Dashboard",
    //         to: "/app/Dashboard",
    //         icon: LayoutDashboardIcon,
    //       },
    //     ]
    //   : []),

  ];

  const profileImage =  
    userData?.profilePicture
      ? userData?.profilePicture.includes("data:image")
        ? userData?.profilePicture
        : userData?.profilePicture !== ""
        ? `${databaseLink}${userData?.profilePicture}`
        : userDefaultImage
      : userDefaultImage;


  return (
    <>
      <header className="sticky top-0 w-full bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.18),transparent_35%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] backdrop-blur-xl" style={{zIndex: "9999"}}>
        <div className="mx-auto flex h-[78px] w-full items-center justify-between px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2">
            <motion.button
              whileTap={{ scale: 0.98 }}
              onClick={() => navigate("/app/ProjectSetup")}
              className="flex items-center z-50 gap-3 rounded-2xl border border-slate-200/80 bg-white px-3 py-2 shadow-[0_10px_30px_rgba(15,23,42,0.06)] focus:outline-none cursor-pointer"
              type="button"
            >
              <img src="https://cdn.prod.website-files.com/669f9a7768d5838eeab813ff/697c817702dc31f302e74738_eph-logo-10jahre-final-p-2000.png" alt="Company logo" className="h-9 w-auto" />
              {/* <img src={logo} alt="Company logo" className="h-9 w-auto" /> */}
              <div className="hidden xl:block">
                <p className="text-sm font-semibold text-slate-800">expertpowerhouse</p>
                <p className="text-[11px] text-slate-500">Workspace</p>
              </div>
            </motion.button>

            {/* Main navlink items in the middle*/}
            <div className="hidden md:flex items-center rounded-2xl z-50 border border-slate-200/80 bg-white p-1 shadow-[0_10px_30px_rgba(15,23,42,0.05)]">
              {navItems.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink key={item.to} to={item.to} end>
                    {({ isActive }) => (
                      <motion.span
                        whileTap={{ scale: 0.98 }}
                        className={[
                          "relative inline-flex h-11 items-center gap-1 rounded-xl md:px-1 lg:px-3 xl:px-4 text-sm font-medium transition-all duration-200 cursor-pointer",
                          isActive
                            ? "bg-[#365561] text-white shadow-[0_10px_24px_rgba(54,85,97,0.22)]"
                            : "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
                        ].join(" ")}
                      >
                        <Icon className="h-4 w-4" />
                        {item.label}

                        {item.badge > 0 && (
                          <span className="absolute -top-2 -right-0 inline-flex w-[22px] h-[22px] items-center justify-center rounded-full bg-red-500  text-[10px] font-semibold text-white shadow">
                            {item.badge}
                          </span>
                        )}
                      </motion.span>
                    )}
                  </NavLink>
                );
              })}
            </div>
          </div>

          {/* <motion.div
            initial={{ x: "100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100%", opacity: 0 }}
            transition={{ duration: 0.22, ease: "easeOut" }}
            className="hidden xl:flex flex-wrap justify-center items-center opacity-80 rounded-2xl border border-slate-200/80 bg-white h-[53px] px-3 shadow-[0_10px_30px_rgba(15,23,42,0.06)] focus:outline-none cursor-pointer"
            hidden = {!userData?.username?.includes("Bappi")}
          >
            EPH Live
          </motion.div> */}
          
          {/* Action buttons on the right */}
          <div className="flex items-center z-50 gap-1 lg:gap-2">

            {/* Search bar */}
            <motion.form
              onSubmit={handleSearch}
              animate={{ width: searchExpanded ? 260 : 44}}
              transition={{ duration: 0.28, ease: "easeInOut" }}
              className="relative hidden md:flex h-[53px] ml-auto items-center gap-2 overflow-visible rounded-2xl border border-slate-200/80 bg-white px-2.5 shadow-[0_10px_30px_rgba(15,23,42,0.05)] transition-[box-shadow,border-color] duration-300 focus-within:border-[#365561]/25 focus-within:shadow-[0_12px_36px_rgba(54,85,97,0.10)]"
            >
              {isSearching ? (
                <i className="fa-solid fa-spinner fa-spin ml-[3px]"></i>
              ) : (
                <Search
                  onClick={() => {
                    setSearchExpanded(!searchExpanded);
                    requestAnimationFrame(() => inputRef.current?.focus());
                  }}
                  className="h-5 w-5 shrink-0 cursor-pointer"
                />
              )}

              <input
                ref={inputRef}
                type="text"
                value={searchInput}
                onFocus={() => {
                  setSearchExpanded(true);
                  setSearchSuggestionOpen(true);
                }}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                  clearSelectedExpertSuggestion();
                  setSearchSuggestionOpen(true);
                }}
                placeholder="Search clients and consultants"
                className="w-full bg-transparent text-sm text-slate-700 outline-none placeholder:text-slate-400"
              />

              <AnimatePresence>
                {searchExpanded &&
                  searchSuggestionOpen &&
                  consultantSuggestions.length > 0 && (
                    <motion.div
                      initial={{ opacity: 0, y: -4 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -4 }}
                      className="absolute left-0 right-0 top-full z-[120] mt-2 max-h-80 overflow-y-auto rounded-2xl border border-slate-200 bg-white py-1 shadow-[0_20px_50px_rgba(15,23,42,0.18)]"
                    >
                      {consultantSuggestions.map((expert) => {
                        const picture = expert?.profilePicture
                          ? String(expert.profilePicture).includes("/pictures/")
                            ? `${databaseLink}${expert.profilePicture}`
                            : expert.profilePicture
                          : userDefaultImage;

                        return (
                          <button
                            key={expert.id}
                            type="button"
                            onMouseDown={(event) => {
                              event.preventDefault();
                              selectExpertSuggestion(expert);
                            }}
                            className="flex w-full min-w-0 items-center gap-3 px-3 py-2 text-left transition hover:bg-slate-50 focus:bg-slate-50 focus:outline-none"
                          >
                            <img
                              src={picture}
                              alt=""
                              className="h-9 w-9 shrink-0 rounded-xl object-cover"
                              onError={(event) => {
                                event.currentTarget.src = userDefaultImage;
                              }}
                            />
                            <span className="min-w-0 flex-1">
                              <span className="block truncate text-sm font-semibold text-slate-800">
                                {expert.name}
                              </span>
                              <span className="block truncate text-[11px] text-slate-500">
                                Consultant ID: {expert.id}
                              </span>
                            </span>
                          </button>
                        );
                      })}
                    </motion.div>
                  )}
              </AnimatePresence>
            </motion.form>

            <AnimatePresence mode="wait" initial={false}>
              {searchExpanded ? (
                // Search back button
                <motion.button
                  key="search-back"
                  initial={{ x: "100%", opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: "100%", opacity: 0 }}
                  transition={{ duration: 0.22, ease: "easeOut" }}
                  whileTap={{ scale: 0.96 }}
                  onClick={() => {
                    setSearchExpanded(false);
                    setSearchInput("");
                    setSearchSuggestionOpen(false);
                    setSelectedExpertSuggestion(null);
                    inputRef.current?.blur();
                  }}
                  className="hidden md:inline-flex h-[53px] w-11 items-center justify-center rounded-2xl border border-slate-200/80 bg-white text-slate-600 shadow-[0_10px_30px_rgba(15,23,42,0.05)] focus:outline-none"
                  type="button"
                  aria-label="Collapse search"
                >
                  <i className="fa-solid fa-arrow-left"></i>
                </motion.button>
              ) : (
                <motion.div
                  key="right-controls"
                  initial={{ x: "100%", opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: "100%", opacity: 0 }}
                  transition={{ duration: 0.22, ease: "easeOut" }}
                  className="flex items-center gap-1 lg:gap-2"
                >
                  <NotificationsPanel />

                  {/* Profile dropdown with picture */}
                  <div className="relative" ref={profileRef}>
                    <motion.button
                      whileTap={{ scale: 0.98 }}
                      onClick={() => setProfileOpen((prev) => !prev)}
                      className="flex h-[53px] items-center gap-2 rounded-2xl border border-slate-200/80 bg-white p-1 pr-3 shadow-[0_10px_30px_rgba(15,23,42,0.06)] transition hover:bg-slate-50 focus:outline-none"
                      type="button"
                    >
                      <img
                        src={profileImage}
                        alt="User"
                        className="h-9 w-9 rounded-xl object-cover"
                        onError={(e) => {
                          e.currentTarget.src = userDefaultImage;
                        }}
                      />
                      <div className="hidden text-left lg:block">
                        <p className="max-w-[110px] truncate text-[13px] font-semibold text-slate-800">
                          {userData?.username || "User"}
                        </p>
                      </div>
                      <ChevronDown className="h-4 w-4 text-slate-400" />
                    </motion.button>

                    <AnimatePresence>
                      {profileOpen && (
                        <motion.div
                          initial={{ opacity: 0, y: 10, scale: 0.98 }}
                          animate={{ opacity: 1, y: 0, scale: 1 }}
                          exit={{ opacity: 0, y: 8, scale: 0.98 }}
                          transition={{ duration: 0.18 }}
                          className="absolute right-0 mt-3 w-72 overflow-hidden rounded-3xl border border-slate-200/80 bg-white p-2 shadow-[0_24px_60px_rgba(15,23,42,0.14)] backdrop-blur-xl"
                        >
                          <div className="mb-2 rounded-2xl bg-slate-50 p-3">
                            <p className="truncate text-sm font-semibold text-slate-900">
                              {userData?.username || "User"}
                            </p>
                            <p className="truncate text-[11px] text-slate-500">
                              {userData?.email || "No email available"}
                            </p>
                          </div>

                          <button
                            hidden = {!(userData?.username?.includes("Bappi") || userData?.username?.includes("David"))}
                            onClick={() => {
                              setProfileOpen(false);
                              navigate("/app/Dashboard");
                            }}
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
                            type="button"
                          >
                            <LayoutDashboardIcon className="h-4 w-4" />
                            Dashboard
                          </button>

                          <button
                            hidden = {!userData?.username?.includes("Bappi")}
                            onClick={() => {
                              setProfileOpen(false);
                              navigate("/app/EphMail");
                            }}
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
                            type="button"
                          >
                            <Mails className="h-4 w-4" />
                            EPH Email
                          </button>

                          <button
                            hidden = {!userData?.username?.includes("Bappi")}
                            onClick={() => {
                              setProfileOpen(false);
                              navigate("/app/FrontendTestPage");
                            }}
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
                            type="button"
                          >
                            <CodeSquare className="h-4 w-4" />
                            Frontend Test Page
                          </button>

                          <button
                            onClick={() => {
                              setProfileOpen(false);
                              navigate("/app/AccountSettings");
                            }}
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
                            type="button"
                          >
                            <Settings className="h-4 w-4" />
                            Account Settings
                          </button>

                          <button
                            hidden = {!userData?.roles?.includes("Admin")}
                            onClick={() => {
                              setProfileOpen(false);
                              navigate("/app/ProjectProgressGantt");
                            }}
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
                            type="button"
                          >
                            <ChartColumnIcon className="h-4 w-4" />
                            Projects Data
                          </button>

                          <button
                            hidden = {!userData?.roles?.includes("Admin")}
                            onClick={() => {
                              setProfileOpen(false);
                              fetchExcel();
                            }}
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
                            type="button"
                          >
                            <ChartColumnIcon className="h-4 w-4" />
                            Quarterly Data
                          </button>

                          <button
                            hidden = {!userData?.roles?.includes("Admin")}
                            onClick={() => {
                              setProfileOpen(false);
                              navigate("/app/ManageUsers");
                            }}
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
                            type="button"
                          >
                            <UserCog2Icon className="h-4 w-4" />
                            Manage Users
                          </button>

                          <button
                            hidden = {!userData?.roles?.includes("Admin")}
                            onClick={() => {
                              setProfileOpen(false);
                              navigate("/app/BlackListedExperts");
                            }}
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
                            type="button"
                          >
                            <UserRoundXIcon className="h-4 w-4" />
                            Blacklisted Experts
                          </button>

                          <div
                            hidden = {!userData?.roles?.includes("Admin")}
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none"
                          >
                            {sanitize ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                            Sanitize View
                            <div class="custom-control custom-switch">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch1"
                                onChange={() => {
                                  setSanitize(!sanitize);
                                }}
                              />
                              <label class="custom-control-label cursor-pointer" for="customSwitch1" />
                            </div>
                          </div>

                          <div className="my-2 h-px bg-slate-200" />

                          <button
                            className="flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-medium text-rose-600 transition hover:bg-rose-50 focus:outline-none"
                            type="button"
                            onClick={handleLogout}
                          >
                            <LogOut className="h-4 w-4" />
                            Log out
                          </button>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Menubar for small screen */}
            <motion.button
              whileTap={{ scale: 0.96 }}
              onClick={() => setMobileOpen(true)}
              className="inline-flex md:hidden h-12 w-11 items-center justify-center rounded-2xl border border-slate-200/80 bg-white text-slate-600 shadow-[0_10px_30px_rgba(15,23,42,0.05)] focus:outline-none"
              type="button"
              aria-label="Open menu"
            >
              <Menu className="h-5 w-5" />
            </motion.button>
          </div>
        </div>
      </header>

      <AnimatePresence>
        {mobileOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setMobileOpen(false)}
              className="fixed inset-0 z-40 bg-slate-900/30 backdrop-blur-sm md:hidden"
            />

            <motion.aside
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'spring', stiffness: 320, damping: 30 }}
              className="fixed right-0 top-0 flex h-full w-[88%] max-w-sm flex-col border-l border-slate-200 bg-white px-4 py-3 shadow-[0_20px_50px_rgba(15,23,42,0.14)] lg:hidden"
              style={{zIndex: 19999}}
            >
              <div className="mb-6 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <img
                    src="https://cdn.prod.website-files.com/669f9a7768d5838eeab813ff/697c817702dc31f302e74738_eph-logo-10jahre-final-p-2000.png"
                    alt="Company logo"
                    className="h-8 w-auto cursor-pointer"
                    onClick={() => {
                      navigate('/app/ProjectSetup');
                      setMobileOpen(false);
                    }}
                  />
                </div>

                <button
                  onClick={() => setMobileOpen(false)}
                  className="rounded-2xl border border-slate-200 bg-white p-2.5 text-slate-600 shadow-sm focus:outline-none"
                  type="button"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              <form onSubmit={handleSearch} className="mb-6">
                <div className="relative flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
                  {isSearching ? <i class="fa-solid fa-spinner fa-spin"></i> : <Search className="h-4 w-4 text-slate-400" />}
                  <input
                    type="text"
                    value={searchInput}
                    onFocus={() => setSearchSuggestionOpen(true)}
                    onChange={(e) => {
                      setSearchInput(e.target.value);
                      clearSelectedExpertSuggestion();
                      setSearchSuggestionOpen(true);
                    }}
                    placeholder="Search"
                    className="w-full bg-transparent text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none"
                  />

                  <AnimatePresence>
                    {searchSuggestionOpen && consultantSuggestions.length > 0 && (
                      <motion.div
                        initial={{ opacity: 0, y: -4 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -4 }}
                        className="absolute left-0 right-0 top-full z-[200] mt-2 max-h-72 overflow-y-auto rounded-2xl border border-slate-200 bg-white py-1 shadow-[0_20px_50px_rgba(15,23,42,0.18)]"
                      >
                        {consultantSuggestions.map((expert) => {
                          const picture = expert?.profilePicture
                            ? String(expert.profilePicture).includes("/pictures/")
                              ? `${databaseLink}${expert.profilePicture}`
                              : expert.profilePicture
                            : userDefaultImage;

                          return (
                            <button
                              key={expert.id}
                              type="button"
                              onMouseDown={(event) => {
                                event.preventDefault();
                                selectExpertSuggestion(expert);
                              }}
                              className="flex w-full min-w-0 items-center gap-3 px-3 py-2 text-left transition hover:bg-slate-50"
                            >
                              <img
                                src={picture}
                                alt=""
                                className="h-9 w-9 shrink-0 rounded-xl object-cover"
                                onError={(event) => {
                                  event.currentTarget.src = userDefaultImage;
                                }}
                              />
                              <span className="min-w-0 flex-1">
                                <span className="block truncate text-sm font-semibold text-slate-800">
                                  {expert.name}
                                </span>
                                <span className="block truncate text-[11px] text-slate-500">
                                  Consultant ID: {expert.id}
                                </span>
                              </span>
                            </button>
                          );
                        })}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </form>

              <div className="space-y-2">
                {navItems.map((item) => {
                  const Icon = item.icon;
                  return (
                    <NavLink
                      key={item.to}
                      to={item.to}
                      end
                      onClick={() => setMobileOpen(false)}
                      className={({ isActive }) =>
                        [
                          'flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-medium transition',
                          isActive
                            ? 'bg-[#365561] text-white shadow-[0_10px_24px_rgba(54,85,97,0.22)]'
                            : 'text-slate-700 hover:bg-slate-50',
                        ].join(' ')
                      }
                    >
                      <Icon className="h-4 w-4" />
                      {item.label}
                    </NavLink>
                  );
                })}
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>

      {openPanel && (
        <ExpertSuggestionPanel 
          suggestions={expertProfiles}
          client={clientData}
          onClose={(e) => setOpenPanel(false)}
        />
      )}

      {showSpan && (
        <AnimatePresence>
          <motion.div
            initial={{ x: 300, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 300, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 25 }}
            className="fixed top-[88px] right-4 z-50"
          >
            <div className="flex items-center justify-start gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-[0_20px_50px_rgba(15,23,42,0.15)]">
              
              {/* Left accent */}
              <button className="focus:outline-none" onClick={() => window.location.reload()}>
                <RefreshCcwIcon className="h-8 w-8 text-green-500"/>
              </button>

              {/* Content */}
              <div className="text-sm text-slate-700 leading-5">
                <p className="font-semibold text-slate-900">
                  Update available
                </p>
                <p className="text-[12px] text-slate-500">
                  Please refresh this tab to load the latest version
                </p>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      )}

      {loadingPopup && (
        <AnimatePresence>
          <motion.div
            className="fixed inset-0 bg-black/30 z-30"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          />
        </AnimatePresence>
      )}
    </>
  );
}

export function ExpertSuggestionPanel({ suggestions, client, onClose }) {
  const isDownloaded = "/pictures/";
  const DUMMY_IMG = "https://images.expertpowerhouse.com/kjknoi14214poj0890fldy13koj2lm/pictures/dummy.png"
  const [expertData, setExpertData] = useState(suggestions);

  const [searchExpand, setSearchExpand] = useState(false);
  const [locationExpand, setLocationExpand] = useState(false);
  const [backupData, setBackupData] = useState(suggestions);
  const [filterName, setFilterName] = useState("");
  const [filterLocation, setFilterLocation] = useState("");
  const nameInputRef = useRef(null);
  const locationInputRef = useRef(null);

  useEffect(() => {
    if (filterName || filterLocation) {
      const filteredData = backupData.filter((item) => {
        const name = item?.name?.toLowerCase();
        const location = item?.location?.toLowerCase();
        return (
          name?.includes(filterName?.toLowerCase()) &&
          location?.includes(filterLocation?.toLowerCase())
        );
      });
      setExpertData(filteredData);
    } else {
      setExpertData(backupData);
    }
  }, [filterName, filterLocation, backupData]);

  const resolveProfileImage = (profilePicture, isDownloaded) => {
    if (!profilePicture || typeof profilePicture !== "string") {
      return DUMMY_IMG;
    }

    const trimmed = profilePicture.trim();
    if (!trimmed) return DUMMY_IMG;

    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;
    }

    if (isDownloaded && trimmed.includes(isDownloaded)) {
      return `https://images.expertpowerhouse.com${trimmed}`;
    }

    return DUMMY_IMG;
  };

  function convertDateObject(date) {
    const formatterDate = new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      weekday: 'long',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    const time = new Date(date);

    const parts = formatterDate.formatToParts(time);
    const weekday = parts.find(p => p.type === 'weekday').value;
    const day = parts.find(p => p.type === 'day').value;
    const month = parts.find(p => p.type === 'month').value;
    const year = parts.find(p => p.type === 'year').value;

    return {
      weekday,
      day,
      month,
      year,
    };
  };

  function getAvailableBorder(availablityDate) {
    if (!availablityDate) return "";

    const today = new Date();
    const availDate = new Date(availablityDate);

    if ( availablityDate === "Wed, 01 Jan 2020 00:00:00 GMT" || availablityDate === "Fri, 01 Jan 2010 00:00:00 GMT") {
      return "";
    } else if (availDate < today) {
      return "rounded-tl rounded-bl border-2 border-green-500";
    } else if (availDate > today) {
      return "rounded-tl rounded-bl border-2 border-red-500";
    }
  };

  return (
    <AnimatePresence>
      {/* Background Overlay */}
      <motion.div
        className="fixed inset-0 bg-black/30 z-30"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        onClick={onClose}
      />

      {/* Panel */}
      <motion.div
        className="fixed top-[78px] right-0 h-full w-[800px] bg-white shadow-xl z-40 pt-2 px-4 pb-6 flex flex-col shadow"
        initial={{ x: "100%" }}
        animate={{ x: 0 }}
        exit={{ x: "100%" }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        style={{ zIndex: 9999 }}
      >
        <div className="flex justify-between items-center mb-4 border-bottom ">
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">Consultant / Client search results</h2>
          <button
            className="text-gray-500 hover:text-black hover:bg-gray-200 border border-gray-500 px-[8px] py-[1px] rounded-full transition"
            onClick={onClose}
          >
            <i className="fa-solid fa-xmark text-lg"></i>
          </button>
        </div>

        <div className="space-y-3 overflow-y-auto flex-1">
          {client?.length > 0 && (
            <div className="list-group mb-10">
              <h2 className="text-md font-semibold mb-2">{client.length} Client are found</h2>
              {client.map((clientProfile) => (
                <a
                  key={clientProfile.name}
                  href={`/app/AccountDetails/${clientProfile.projectID}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="list-group-item list-group-item-action list-group-item-light"
                >
                  {clientProfile.name}
                </a>
              ))}
            </div>
          )}

          
          {/* Title and search bars */}
          <h2 className="text-md font-semibold">{expertData.length} Consultants are found</h2>
          {/* search bars */}
          <div className="left-[280px] w-[700px]">
            <ul className="search-con-filters list-unstyled form-inline">
              <li className="search-con-name-filter">
                <span className="no-select">search name</span>
                <div className="search-con-search-box">
                  <input
                    className={
                      searchExpand
                        ? "search-con-search-input search-con-filter-expand"
                        : "search-con-search-input"
                    }
                    placeholder="Search Name"
                    onChange={(e) => setFilterName(e.target.value)}
                    value={filterName}
                    ref={nameInputRef}
                  />
                  <i
                    className="search-con-search-icon fa-solid fa-magnifying-glass"
                    onClick={(e) => {
                      setSearchExpand(!searchExpand);
                      // nameInputRef.current.focus()
                    }}
                  />
                </div>
              </li>
              <li className="search-con-location-filter ml-[100px]">
                <span className="no-select">Location</span>
                <div className="search-con-searchLoc-box ml-1">
                  <input
                    className={
                      locationExpand
                        ? "search-con-searchLoc-input search-con-location-expand"
                        : "search-con-searchLoc-input"
                    }
                    placeholder="Location"
                    onChange={(e) => setFilterLocation(e.target.value)}
                    value={filterLocation}
                    ref={locationInputRef}
                  />
                  <i
                    className="search-con-searchLoc-icon fa-solid fa-magnifying-glass"
                    onClick={(e) => {
                      setLocationExpand(!locationExpand);
                      // locationInputRef.current.focus()
                    }}
                  />
                </div>
              </li>
            </ul>
          </div>
          {/* ----------------- */}

          {expertData.length > 0 ? (
            <>
              {expertData.map((data) => (
                <div
                  key={data.id}
                  className="flex border rounded-lg shadow-sm hover:bg-gray-50 transition overflow-hidden cursor-pointer"
                  onClick={() => {window.open(`/app/ExpertDetails/${data.id}`, "_blank", "noopener,noreferrer");}}
                >
                  {(() => {
                    const available = getAvailableBorder(data.available_from);
                    return (
                      <a className={`shrink-0 ${available}`}>
                        <div
                          className="flex-item-share-profile-item-profile-picture"
                          style={{
                            width: "90px",
                            height: "100%",
                            backgroundColor: "#365561",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundImage: `url(${resolveProfileImage(
                              data.profile_picture,
                              isDownloaded
                            )})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                        />
                      </a>
                    );
                  })()}

                  <div className="flex-1 min-w-0 p-2">
                    <div className="flex flex-row justify-between">
                      <p className="text-lg font-medium text-gray-800 truncate">
                        {data.name}
                      </p>
                      <div onClick={(e) => {e.stopPropagation();}}>
                        <AddToProject
                          expertID={data.id}
                          btnName={" Project"}
                        />
                      </div>
                    </div>

                    {/* 2-column grid so widths stay consistent */}
                    <div className="mt-2 grid grid-cols-[260px_minmax(0,1fr)] gap-3">
                      {/* Middle: fixed width */}
                      <div className="min-w-0 w-[260px] flex-col justify-between">
                        <div className="min-h-[140px]">
                          <div className="flex items-start gap-2">
                            <span className="leading-5 shrink-0">📧</span>
                            <span className="text-sm text-gray-500 leading-5 break-words">
                              {data.email || "No info"}
                            </span>
                          </div>

                          <div className="flex items-start gap-2 mt-1">
                            <span className="leading-5 shrink-0">🌍</span>
                            <span className="text-sm text-gray-500 leading-5 break-words">
                              {data.location || "No location data"}
                            </span>
                          </div>

                          <div className="flex items-start gap-2 mt-1">
                            <span className="leading-5 shrink-0">💬</span>
                            <span className="text-sm text-gray-500 leading-5 break-words line-clamp-2">
                              {data.available_comment || "No availability comment"}
                            </span>
                          </div>

                          {(() => {
                            const time = convertDateObject(data.available_from);

                            if (!time) return null; // safety guard

                            return (
                              <div className="flex items-start gap-2 mt-1">
                                <span className="leading-5 shrink-0">📆</span>
                                <span className="text-sm text-gray-500 leading-5 break-words line-clamp-2">
                                  {`${time.weekday}, ${time.day} ${time.month} ${time.year}`}
                                </span>
                              </div>
                            );
                          })()}

                        </div>

                        <li className="search-con-exLogo-section list-none">
                          {data.logo1 ? <img src={data.logo1} alt="" /> : null}
                          {data.logo2 ? <img src={data.logo2} alt="" /> : null}
                          {data.logo3 ? <img src={data.logo3} alt="" /> : null}
                          {data.logo4 ? <img src={data.logo4} alt="" /> : null}
                          {data.logo5 ? <img src={data.logo5} alt="" /> : null}
                        </li>
                      </div>

                      {/* Right: takes remaining space, but doesn't get pushed by middle */}
                      <div className="min-w-0 space-y-2">
                        <div>
                          <p className="text-xs text-gray-500 font-medium mb-1">Summary</p>
                          <div className="bg-gray-100 p-2 rounded text-sm text-gray-700 h-16 overflow-y-auto whitespace-pre-wrap break-words">
                            {data.summary || "No summary available."}
                          </div>
                        </div>

                        <div>
                          <p className="text-xs text-gray-500 font-medium mb-1">Experience</p>
                          <div className="bg-gray-100 p-2 rounded text-sm text-gray-700 h-16 overflow-y-auto whitespace-pre-wrap break-words">
                            {data.experience || "No experience provided."}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <p className="text-gray-500 text-sm">No experts found.</p>
          )}
        </div>

        <div className="mb-[70px]"></div>
      </motion.div>
    </AnimatePresence>
  );
}


export function NotificationsPanel() {
  const {
    notifications,
    projNotifications,
    getToKnowNotifications,
    expertCallNotifications,
    invitationsAccepted,
    joinNotifications,
    clientNotifications,
    setClientNotifications,
    projectEndingNotifications,
    ratingNotifications,
    clientFeedbackNotifications,
    setClientFeedbackNotifications,
  } = useContext(UserContext);

  const [composeEmail, setComposeEmail] = useState(false);
  const [emailDetails, setEmailDetails] = useState("");
  const [loadingPopup, setLoadingPopup] = useState(false);

  const { API_URL } = useContext(UrlContext);
  const navigate = useNavigate();

  const [showNotification, setShowNotification] = useState(false);
  const [groupedClientNotifications, setGroupedClientNotifications] = useState(
    []
  );
  const [sortedNotifications, setSortedNotifications] = useState([]);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [ratingModalExperts, setRatingModalExperts] = useState([]);
  const [activeRatingNotification, setActiveRatingNotification] = useState(null);
  const [activeFeedbackNotification, setActiveFeedbackNotification] = useState(null);

  const notificationRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setTimeout(() => {
          setShowNotification(false);
        }, 100);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const result = clientNotifications.reduce((acc, item) => {
      const existing = acc.find((el) => el.zohoID === item.zohoID);
      if (existing) {
        existing.count += 1;
      } else {
        acc.push({ ...item, count: 1 });
      }
      return acc;
    }, []);
    setGroupedClientNotifications(result);
  }, [clientNotifications]);

  useEffect(() => {
    const array = [
      ...notifications,
      ...projNotifications,
      ...getToKnowNotifications,
      ...expertCallNotifications,
      ...invitationsAccepted,
      ...joinNotifications,
      ...groupedClientNotifications,
      ...projectEndingNotifications,
      ...ratingNotifications,
      ...clientFeedbackNotifications,
    ];
    array.sort((a, b) => new Date(b.date) - new Date(a.date));
    setSortedNotifications(array);
  }, [
    notifications,
    projNotifications,
    getToKnowNotifications,
    expertCallNotifications,
    invitationsAccepted,
    joinNotifications,
    groupedClientNotifications,
    projectEndingNotifications,
    ratingNotifications,
    clientFeedbackNotifications,
  ]);

  const handleProjectNameCrossClick = (event, projectID, notification) => {
    event.preventDefault();
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    const url = `${API_URL}update-project-dates`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ projectID }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          const updateItems = sortedNotifications.filter(
            (item) => item !== notification
          );
          setSortedNotifications(updateItems);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const handleProjectNameClick = (event, projectID) => {
    event.preventDefault();
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    const url = `${API_URL}update-project-dates`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ projectID }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          window.location.href = `/app/ProjectDetails/${projectID}`;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const handleNotificationClick = (event, notificationData, clicked) => {
    if (event?.preventDefault) {
      event.preventDefault();
    }

    const projID = notificationData.projectID;
    const notificationType = notificationData.type;

    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    const url = `${API_URL}update-notifications`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ notificationData }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          if (clicked === "notification") {
            if (notificationType === "Get-to-know") {
              const updateItems = sortedNotifications.filter(
                (item) => item !== notificationData
              );
              setSortedNotifications(updateItems);
              window.location.href = `/app/ProjectDetails/${projID}`;
            } else if (notificationType === "Expert Call") {
              const updateItems = sortedNotifications.filter(
                (item) => item !== notificationData
              );
              setSortedNotifications(updateItems);
              window.location.href = `/app/ProjectDetails/${projID}`;
            } else if (notificationType === "Invitation-accepted") {
              const updateItems = sortedNotifications.filter(
                (item) => item !== notificationData
              );
              setSortedNotifications(updateItems);
            } else if (notificationType === "Request-join") {
              const updateItems = sortedNotifications.filter(
                (item) => item !== notificationData
              );
              setSortedNotifications(updateItems);
            } else if (notificationType === "Client-notification") {
              const updateItems = clientNotifications.filter(
                (item) => item.projectID !== notificationData.projectID
              );
              setClientNotifications(updateItems);
            }
          } else {
            if (
              notificationType === "Get-to-know" ||
              notificationType === "Expert Call" ||
              notificationType === "Invitation-accepted" ||
              notificationType === "Request-join" ||
              notificationType === "Project Ending" ||
              notificationType === "Rate Notification" ||
              notificationType === "Client Feedback"
            ) {
              const updateItems = sortedNotifications.filter(
                (item) => item !== notificationData
              );
              setSortedNotifications(updateItems);
            } else if (notificationType === "Client-notification") {
              const updateItems = clientNotifications.filter(
                (item) => item.projectID !== notificationData.projectID
              );
              setClientNotifications(updateItems);
            }
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const handleEmailButtonCloseClick = (expertID, notification) => {
    const url = `${API_URL}navbar-close-email`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ expertID }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          const updateItems = sortedNotifications.filter(
            (item) => item !== notification
          );
          setSortedNotifications(updateItems);
          setEmailDetails(data.emailDetails);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const handleEmailButtonClick = (expertID, notification) => {
    setLoadingPopup(true);
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    const url = `${API_URL}navbar-send-email`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ expertID }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          const updateItems = sortedNotifications.filter(
            (item) => item !== notification
          );
          setSortedNotifications(updateItems);
          setEmailDetails(data.emailDetails);
          setComposeEmail(true);
          setLoadingPopup(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  function timeAgo(unixTimestamp) {
    const now = Date.now();
    const difference = now - unixTimestamp * 1000;

    const absDifference = Math.abs(difference);
    const minutes = Math.floor(absDifference / (1000 * 60));
    const hours = Math.floor(absDifference / (1000 * 60 * 60));
    const days = Math.floor(absDifference / (1000 * 60 * 60 * 24));
    const months = Math.floor(absDifference / (1000 * 60 * 60 * 24 * 30));

    if (difference >= 0) {
      if (minutes < 60) {
        return minutes === 1 ? "a minute ago" : `${minutes} minutes ago`;
      } else if (hours < 24) {
        return hours === 1 ? "an hour ago" : `${hours} hours ago`;
      } else if (days < 2) {
        return "yesterday";
      } else if (days < 30) {
        return `${days} days ago`;
      } else {
        return months === 1 ? "a month ago" : `${months} months ago`;
      }
    } else {
      if (minutes < 60) {
        return minutes === 1 ? "in a minute" : `in ${minutes} minutes`;
      } else if (hours < 24) {
        return hours === 1 ? "in an hour" : `in ${hours} hours`;
      } else if (days < 2) {
        return "tomorrow";
      } else if (days < 30) {
        return `in ${days} days`;
      } else {
        return months === 1 ? "in a month" : `in ${months} months`;
      }
    }
  }

  const handleRatingNotificationClick = (event, notification) => {
    event.preventDefault();
    setRatingModalExperts(notification.experts);
    setActiveRatingNotification(notification);
    setShowRatingModal(true);
    setShowNotification(false); // the popup opens over the page, not under this panel
  };

  const renderNotificationRow = (item, index) => {
    const cardBase =
      "relative rounded-2xl border border-slate-200 bg-white p-3 shadow-sm transition hover:bg-slate-50";
    const closeBtn =
      "absolute right-2 top-2 inline-flex h-7 w-7 items-center justify-center rounded-xl text-slate-400 transition hover:bg-slate-100 hover:text-slate-700";
    const meta = "mt-2 text-[11px] text-slate-500";
    const actionLink = "font-semibold text-[#365561]";
    const iconBtn =
      "inline-flex h-8 w-8 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50";

    if (item.type === "notifications") {
      return (
        <div key={index} className={cardBase}>
          <button
            className={closeBtn}
            onClick={() => handleEmailButtonCloseClick(item.expertID, item)}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="pr-8">
            <div className="flex items-start justify-between gap-3">
              <p className="text-sm leading-6 text-slate-700">
                <a
                  href={`/app/ExpertDetails/${item.expertID}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={actionLink}
                >
                  {item.expertName}
                </a>{" "}
                is going to be available soon!
              </p>

              {!item.emailSent ? (
                <button
                  type="button"
                  className={iconBtn}
                  onClick={() => handleEmailButtonClick(item.expertID, item)}
                  title="Send Email"
                >
                  <Mails className="h-4 w-4" />
                </button>
              ) : (
                <span className="rounded-xl bg-emerald-50 px-2.5 py-1 text-[11px] font-medium text-emerald-700">
                  Email Sent
                </span>
              )}
            </div>

            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </div>
        </div>
      );
    }

    if (item.type === "project") {
      return (
        <div key={index} className={cardBase}>
          <button
            className={closeBtn}
            onClick={(event) => handleProjectNameCrossClick(event, item.projectID, item)}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="pr-8">
            <p className="text-sm leading-6 text-slate-700">
              The project{" "}
              <a
                href=""
                rel="noopener noreferrer"
                className={actionLink}
                onClick={(event) => handleProjectNameClick(event, item.projectID)}
              >
                {item.projectName} ({item.zohoID})
              </a>{" "}
              is idle for a while. Please take the necessary action.
            </p>
            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </div>
        </div>
      );
    }

    if (item.type === "Get-to-know") {
      return (
        <div key={index} className={cardBase}>
          <button
            className={closeBtn}
            onClick={(event) => handleNotificationClick(event, item, "close")}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <a
            href=""
            rel="noopener noreferrer"
            onClick={(event) =>
              handleNotificationClick(event, item, "notification")
            }
            className="block pr-8"
          >
            <p className="text-sm leading-6 text-slate-700">
              The Get-To-Know call with <b>{item.expertName}</b> in the project{" "}
              <b>{item.zohoID}</b> was conducted. Do follow-up with the expert.
            </p>
            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </a>
        </div>
      );
    }

    if (item.type === "Expert Call") {
      return (
        <div key={index} className={cardBase}>
          <button
            className={closeBtn}
            onClick={(event) => handleNotificationClick(event, item, "close")}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <a
            href=""
            rel="noopener noreferrer"
            onClick={(event) =>
              handleNotificationClick(event, item, "notification")
            }
            className="block pr-8"
          >
            <p className="text-sm leading-6 text-slate-700">
              The Expert Call with <b>{item.expertName}</b> in the project{" "}
              <b>{item.zohoID}</b> was conducted. Do process the expert for
              finalization.
            </p>
            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </a>
        </div>
      );
    }

    if (item.type === "Invitation-accepted") {
      return (
        <div
          key={index}
          className={`${cardBase} cursor-pointer`}
          onClick={(event) => {
            navigate(`/app/ProjectDetails/${item.projectID}`);
            handleNotificationClick(event, item, "notification");
          }}
        >
          <button
            className={closeBtn}
            onClick={(event) => {event.stopPropagation(); handleNotificationClick(event, item, "close")}}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="pr-8">
            <p className="text-sm leading-6 text-slate-700">
              <b className="text-[#365561]">{item.expertName}</b> has accepted
              your invitation to project{" "}
              <b className="text-[#365561]">{item.zohoID}</b>
            </p>
            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </div>
        </div>
      );
    }

    if (item.type === "Request-join") {
      return (
        <div
          key={index}
          className={`${cardBase} cursor-pointer`}
          onClick={(event) => {
            navigate(`/app/ProjectDetails/${item.projectID}`);
            handleNotificationClick(event, item, "notification");
          }}
        >
          <button
            className={closeBtn}
            onClick={(event) => {
              event.stopPropagation();
              handleNotificationClick(event, item, "close");
            }}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="pr-8">
            <p className="text-sm leading-6 text-slate-700">
              <b className="text-[#365561]">{item.expertName}</b> requested to
              join project <b className="text-[#365561]">{item.zohoID}</b>
            </p>
            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </div>
        </div>
      );
    }

    if (item.type === "Client-notification") {
      return (
        <div
          key={index}
          className={`${cardBase} cursor-pointer`}
          onClick={(event) => {
            navigate(`/app/ProjectSummary/${item.projectID}`);
            handleNotificationClick(event, item, "notification");
          }}
        >
          <button
            className={closeBtn}
            onClick={(event) => {event.stopPropagation(); handleNotificationClick(event, item, "close")}}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="pr-8">
            <p className="text-sm leading-6 text-slate-700">
              <b className="text-[#365561]">Project {item.zohoID}</b> received{" "}
              {item.count > 1 ? `${item.count} new inputs` : "a new input"} from
              client
            </p>
            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </div>
        </div>
      );
    }

    if (item.type === "Project Ending") {
      return (
        <div key={index} className={cardBase}>
          <button
            className={closeBtn}
            onClick={(event) => handleNotificationClick(event, item, "close")}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <a
            href={`/app/ProjectInformation/${item.projectID}/${item.expertID}/0/1`}
            target="_blank"
            rel="noopener noreferrer"
            className="block pr-8"
          >
            <p className="text-sm leading-6 text-slate-700">
              The project{" "}
              <span className={actionLink}>
                {item.projectName} ({item.zohoID})
              </span>{" "}
              with the Expert <b>{item.expertName}</b> is ending soon. Please
              take the necessary action.
            </p>
            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </a>
        </div>
      );
    }

    if (item.type === "Rate Notification") {
      return (
        <div key={index} className={cardBase}>
          <button
            className={closeBtn}
            onClick={(event) => handleNotificationClick(event, item, "close")}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="pr-8">
            <div className="flex items-start justify-between gap-3">
              <p className="text-sm leading-6 text-slate-700">
                Rate your experience with consultant/expert{" "}
                <b>{item.expertName}</b> in project{" "}
                <b>
                  {item.projectName} ({item.zohoID})
                </b>
                .
              </p>

              <button
                type="button"
                className={iconBtn}
                onClick={(e) => handleRatingNotificationClick(e, item)}
                title="Rate Expert"
              >
                <i className="fa fa-star-o" />
              </button>
            </div>

            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </div>
        </div>
      );
    }

    if (item.type === "Client Feedback") {
      return (
        <div key={index} className={cardBase}>
          <button
            className={closeBtn}
            onClick={(event) => handleNotificationClick(event, item, "close")}
            type="button"
            title="Delete Notification"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="pr-8">
            <div className="flex items-start justify-between gap-3">
              <p className="text-sm leading-6 text-slate-700">
                The project{" "}
                <b>
                  {item.projectName} ({item.zohoID})
                </b>{" "}
                finished on {item.finishDate}. Request client feedback.
              </p>

              <button
                type="button"
                className={iconBtn}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveFeedbackNotification(item);
                  setShowNotification(false);
                }}
                title="Request client feedback"
              >
                <i className="fa-regular fa-comment-dots" />
              </button>
            </div>

            {item.date ? <p className={meta}>{timeAgo(item.date)}</p> : null}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <div className="relative" ref={notificationRef}>
        <motion.button
          whileTap={{ scale: 0.98 }}
          onClick={() => setShowNotification((prev) => !prev)}
          className="relative hidden sm:inline-flex h-[53px] w-12 items-center justify-center rounded-2xl border border-slate-200/80 bg-white text-slate-600 shadow-[0_10px_30px_rgba(15,23,42,0.05)] transition hover:bg-slate-50 focus:outline-none"
          type="button"
          aria-label="Notifications"
        >
          <Bell className="h-4.5 w-4.5" />

          {sortedNotifications?.length > 0 && (
            <span className="absolute -right-1 -top-1 inline-flex w-[22px] h-[22px] items-center justify-center rounded-full bg-red-500 text-[10px] font-semibold text-white">
              {sortedNotifications.length}
            </span>
          )}
        </motion.button>

        <AnimatePresence>
          {showNotification && (
            <motion.div
              initial={{ opacity: 0, y: 10, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 8, scale: 0.98 }}
              transition={{ duration: 0.18 }}
              className="absolute right-0 mt-3 w-[420px] overflow-hidden rounded-3xl border border-slate-200/80 bg-white p-2 shadow-[0_24px_60px_rgba(15,23,42,0.14)] backdrop-blur-xl"
            >
              <div className="mb-2 rounded-2xl bg-slate-50 px-3 py-3">
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <p className="text-sm font-semibold text-slate-900">
                      Notifications
                    </p>
                    <p className="text-[11px] text-slate-500">
                      {sortedNotifications.length} item
                      {sortedNotifications.length === 1 ? "" : "s"}
                    </p>
                  </div>

                  <button
                    type="button"
                    onClick={() => setShowNotification(false)}
                    className="inline-flex h-8 w-8 items-center justify-center rounded-xl text-slate-400 transition hover:bg-white hover:text-slate-700"
                  >
                    <X className="h-4 w-4" />
                  </button>
                </div>
              </div>

              <div className="max-h-[480px] space-y-2 overflow-y-auto pr-1">
                {sortedNotifications.length > 0 ? (
                  sortedNotifications.map((item, index) =>
                    renderNotificationRow(item, index)
                  )
                ) : (
                  <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center">
                    <p className="text-sm font-medium text-slate-700">
                      No notifications
                    </p>
                    <p className="mt-1 text-[11px] text-slate-500">
                      You’re all caught up.
                    </p>
                  </div>
                )}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* Portaled: the sticky navbar's backdrop-filter would otherwise trap these fixed popups inside it */}
      {activeFeedbackNotification && createPortal(
        <FeedbackModal
          projectId={activeFeedbackNotification.projectID}
          projectName={activeFeedbackNotification.projectName}
          onClose={() => setActiveFeedbackNotification(null)}
          onChange={() =>
            setClientFeedbackNotifications((prev) => prev.filter((n) => n.ID !== activeFeedbackNotification.ID))
          }
        />,
        document.body
      )}

      {showRatingModal && createPortal(
        <FiveStarRatingModal
          experts={ratingModalExperts}
          onSubmit={async (ratings, comments) => {
            try {
              const ephToken = localStorage.getItem("eph-token");
              const token = JSON.parse(ephToken).value;

              const ratingData = ratingModalExperts.map((expert) => ({
                expertId: expert.ID,
                projectId:
                  activeRatingNotification?.projectID || expert.projectId,
                rating: ratings[expert.ID] || 0,
                comment: comments[expert.ID] || "",
                expertName: expert.expertName,
              }));

              await fetch(`${API_URL}submit-expert-ratings`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "x-access-token": token,
                },
                body: JSON.stringify({ ratings: ratingData }),
              });
            } catch (error) {}

            setShowRatingModal(false);
            setActiveRatingNotification(null);
            setRatingModalExperts([]);
            setSortedNotifications(
              sortedNotifications.filter((n) => n !== activeRatingNotification)
            );
          }}
          onSkip={() => {
            handleNotificationClick(null, activeRatingNotification, "close");
            setShowRatingModal(false);
            setActiveRatingNotification(null);
            setRatingModalExperts([]);
          }}
        />,
        document.body
      )}


      {composeEmail && (
        <EmailComposer
          emailDetails={emailDetails}
          onClose={() => setComposeEmail(false)}
          onSend={(modifiedEmail) => {
            setLoadingPopup(true);

            console.log("Sending modified email:", modifiedEmail);
            const authToken = localStorage.getItem("accesstoken");
            const tokenObj = localStorage.getItem("eph-token");
            const url = `${API_URL}send-email-through-graphapi`;

            fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-access-token": authToken,
                tokenObj: JSON.parse(tokenObj).value,
              },
              body: JSON.stringify(modifiedEmail),
            })
              .then((res) => res.json())
              .then((data) => {
                setLoadingPopup(false);

                if (data.status === "success") {
                  setComposeEmail(false);
                  const updatedNotificationList = notifications.map((item) => {
                    if (item.expertID === modifiedEmail.expertID) {
                      item.emailSent = true;
                    }
                    return item;
                  });
                  // setNotifications(updatedNotificationList);
                  Swal.fire({
                    icon: "success",
                    title: "Email sent successfully",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                } else if (data.status === "error") {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: `${data.message}`,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                }

              })
              .catch((err) => console.log(err));
          }}
        />
      )}
    </>
  );
}
